import React, { Fragment } from 'react';

//Material UI Components
import Checkbox from '@material-ui/core/Checkbox';
import { TextField, Icon, Switch, Select, Popper, MenuItem } from '@material-ui/core';
import InputBase from "@material-ui/core/InputBase";
import SearchIcon from '@material-ui/icons/Search';
import validator from 'validator'
import Grid from '@material-ui/core/Grid';
import Chip from '@material-ui/core/Chip';
import Button from '@material-ui/core/Button';
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import { KeyboardDatePicker, MuiPickersUtilsProvider, KeyboardTimePicker } from '@material-ui/pickers'
import DateFnsUtils from '@date-io/date-fns';
import InputAdornment from '@material-ui/core/InputAdornment';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from 'moment';

//Material UI Lab
import { Autocomplete, createFilterOptions } from '@material-ui/lab';


//Icons
//Material ui Icons
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import IconButton from '@material-ui/core/IconButton';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import ClearIcon from '@material-ui/icons/Clear';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';

//font Awsome Icons
import {
  faClock
} from "@fortawesome/free-solid-svg-icons";
import {  Event } from '@material-ui/icons';
import Image from '../assets/svgs/image';



const renderCorrectIcon = (option) => {

  return (
    <img
      width={'100%'}
      height={'100%'}
      src={option.iconUrl}
      alt={option.name}
    />

  );

};


//JC 08/09/2020
export const renderSwitch = ({
  checked,
  onClick,
  inputClass,
  idToSet = undefined,
}) => {

  let classRoot = 'switchRoot';
  let classTrack = 'switchTrack';
  let classthumb = 'switchThumb';

  if (checked) {
    classthumb = 'switchThumbChecked';
    classTrack = 'switchTrackChecked';
  }
  return (
    <Switch
      id={idToSet}
      size='large'
      checked={checked}
      onClick={onClick}
      classes={{
        root: classRoot,
        thumb: classthumb,
        track: classTrack,
      }}
    >
    </Switch>
  );
}
//JC END 08/09/2020


//LV 07/01/2022
export const renderSwitchV2 = ({
  checked,
  onClick,
  inputClass,
  idToSet = undefined,
}) => {

  let classRoot = 'switchRootV2';
  let classTrack = 'switchTrackV2';
  let classthumb = 'switchThumbV2';

  if (checked) {
    classthumb = 'switchThumbCheckedV2';
    classTrack = 'switchTrackCheckedV2';
  }
  return (
    <Switch
      id={idToSet}
      size='large'
      checked={checked}
      onClick={onClick}
      classes={{
        root: classRoot,
        thumb: classthumb,
        track: classTrack,
      }}
    >
    </Switch>
  );
}
//LV END 07/01/2022

export const renderSwitchV3 = ({
  checked,
  onClick,
  idToSet = undefined,
}) => {

  let classRoot = 'switchRootV3';
  let classTrack = 'switchTrackV3';
  let classthumb = 'switchThumbV3';

  if (checked) {
    classthumb = 'switchThumbCheckedV3';
    classTrack = 'switchTrackCheckedV3';
  }
  return (
    <Switch
      id={idToSet}
      size='small'
      checked={checked}
      onClick={onClick}
      classes={{
        root: classRoot,
        thumb: classthumb,
        track: classTrack,
      }}
    >
    </Switch>
  );
}

export const renderSwitchV4 = ({
  checked,
  onClick,
  idToSet = undefined,
}) => {

  let classRoot = 'switchRootV3';
  let classTrack = 'LswitchTrackV4';
  let classthumb = 'LswitchThumbV4';

  if (checked) {
    classthumb = 'LswitchThumbCheckedV4';
    classTrack = 'switchTrackCheckedV3';
  }
  return (
    <Switch
      id={idToSet}
      size='small'
      checked={checked}
      onClick={onClick}
      classes={{
        root: classRoot,
        thumb: classthumb,
        track: classTrack,
      }}
    >
    </Switch>
  );
}

export const LrenderSwitch = ({
  checked,
  onClick,
  inputClass,
  idToSet = undefined,
}) => {

  let classRoot = 'LswitchRoot';
  let classTrack = 'LswitchTrack';
  let classthumb = 'LswitchThumb';

  if (checked) {
    classthumb = 'LswitchThumbChecked';
    classTrack = 'LswitchTrackChecked';
  }
  return (
    <Switch
      id={idToSet}
      size='large'
      checked={checked}
      onClick={onClick}
      classes={{
        root: classRoot,
        thumb: classthumb,
        track: classTrack,
      }}
    >
    </Switch>
  );
}

export const renderSwitchWithLabelV4 = ({
  labelInLeft = false,
  stylesLabel = {},
  checked,
  onClick,
  label,
  idToSet
}
) => {

  let classRoot = 'switchRootV3';
  let classTrack = 'LswitchTrackV4';
  let classthumb = 'lSwitchThumbWithLabel';


  if (checked) {
    classthumb = 'LSwitchThumbCheckedWithLabel';
    classTrack = 'switchTrackCheckedV3';
  }

  return (
    <Grid id={idToSet ? idToSet + '_container' : 'switch_container'} item container alignItems='center' style={{ padding: '5px 0' }}>
      {
        !labelInLeft ?
          <Grid item container xs={8} sm={8} md={8} style={{ ...stylesLabel }} justifyContent='flex-end' id={idToSet ? idToSet + '_label' : 'switch_label'}>
            {label ? label : ''}
          </Grid>
          :
          undefined
      }
      <Grid item xs={4} sm={4} md={4} lg={2} style={{ padding: '0 15px' }}>
        <Switch
          id={idToSet ? idToSet : 'switch'}
          classes={{
            root: classRoot,
            thumb: classthumb,
            track: classTrack,
          }}
          checked={checked}
          onClick={onClick}>
        </Switch>
      </Grid>
      {
        labelInLeft ?
          <Grid item container xs={8} sm={8} md={8} style={{ ...stylesLabel }} justifyContent='flex-start' id={idToSet ? idToSet + '_label' : 'switch_label'}>
            {label ? label : ''}
          </Grid>
          :
          undefined
      }

    </Grid>

  );
}

export const renderTextField = ({
  startAdornment = undefined, //jsx object of input Adornment
  endAdornment = undefined, //jsx object of input Adornment
  label,
  input,
  inputClass,
  inputLabelClass = undefined,
  rows,
  type = undefined,
  minNum = undefined,
  valueToSet = undefined,
  meta: { touched, invalid, error },
  ...custom
}) => {

  let newInputProps = {}
  if (type && type === 'number' && minNum !== undefined) {
    newInputProps.min = minNum
  }

  let newInputClass = {}
  if (inputClass) {
    newInputClass.input = inputClass
  }

  return (
    <TextField
      style={{ width: '100%', marginLeft: 'auto', marginRight: 'auto', marginTop: 'auto', marginBottom: '0', paddingRight: '15px' }}
      type={type ? type : undefined}
      label={label}
      rows={rows ? rows : undefined}
      multiline={rows ? true : undefined}
      placeholder={label}
      error={touched && invalid}
      helperText={touched && error}
      {...input}
      {...custom}
      // value={valueToSet? valueToSet : undefined}
      InputLabelProps={{ className: inputLabelClass }}
      InputProps={{
        inputProps: newInputProps,
        classes: {
          input: newInputClass,
        },

        startAdornment: startAdornment,
        endAdornment: endAdornment,
      }}
    />
  )
};

export const renderLegacyTextField = ({
  startAdornment = undefined, //jsx object of input Adornment
  endAdornment = undefined, //jsx object of input Adornment
  label,
  input,
  inputClass,
  inputLabelClass = undefined,
  rows,
  type = undefined,
  minNum = undefined,
  valueToSet = undefined,
  isReadOnly,
  meta: { touched, invalid, error },
  ...custom
}) => {

  let newInputProps = {}
  if (type && type === 'number' && minNum !== undefined) {
    newInputProps.min = minNum
  }

  let newInputClass = {}
  if (inputClass) {
    newInputClass.input = inputClass
  }

  return (
    <TextField
      style={{ width: '100%', marginLeft: 'auto', marginRight: 'auto', marginTop: 'auto', marginBottom: '0' }}
      type={type ? type : undefined}
      label={label}
      rows={rows ? rows : undefined}
      multiline={rows ? true : undefined}
      placeholder={label}
      error={touched && invalid}
      helperText={touched && error}
      disabled={isReadOnly ? isReadOnly : false}
      {...input}
      {...custom}
      InputLabelProps={{ className: 'txt_black' }}
      InputProps={{
        inputProps: newInputProps,
        classes: {
          input: 'txt_black',
        },

        startAdornment: startAdornment,
        endAdornment: endAdornment,
      }}
    />
  )
};

export const renderTextFieldPin = ({
  label,
  input,
  inputClass,
  inputLabelClass = undefined,
  placeHolder,
  rows,
  type = undefined,
  minNum = undefined,
  valueToSet = undefined,
  maxLength = 100,
  meta: { touched, invalid, error },
  ...custom
}) => {
  return (
    <TextField
      style={{ width: '100%', height: '0px' }}
      type={type ? type : undefined}
      maxRows={rows ? rows : undefined}
      multiline={true}
      placeholder={placeHolder}
      error={touched && invalid}
      helperText={touched && error}
      {...input}
      {...custom}
      InputProps={{ disableUnderline: true }}
      inputProps={{ maxLength: maxLength }}

    />
  )
};

export const renderTextFieldPinDate = ({
  label,
  input,
  inputClass,
  inputLabelClass = undefined,
  type = undefined,
  minNum = undefined,
  valueToSet = undefined,
  meta: { touched, invalid, error },
  ...custom
}) => {
  return (
    <TextField
      style={{ width: '250px' }}
      type={type ? type : undefined}
      error={touched && invalid}
      helperText={touched && error}
      {...input}
      {...custom}
      inputProps={{ min: 0, style: { textAlign: 'center' } }}
      InputProps={{ disableUnderline: true }}
    />
  )
};

export const renderControledTextField = ({
  startAdornment = undefined, //jsx object of input Adornment
  endAdornment = undefined, //jsx object of input Adornment
  label,
  input,
  inputClass = undefined,
  inputLabelClass = undefined,
  rows,
  type = undefined,
  minNum = undefined,
  valueToSet = undefined,
  disableUnderline = undefined,
  heightToSet = undefined,
  meta: { touched, invalid, error },
  classToRoot = undefined,
  classToInput = undefined,
  ...custom
}) => {
  let newInputProps = {}
  if (type && type === 'number' && minNum !== undefined) {
    newInputProps.min = minNum

  }

  let newInputClass = {}

  if (inputClass) {
    newInputClass.input = inputClass
  }

  return (
    <TextField
      style={{ width: '100%', marginLeft: 'auto', marginRight: 'auto', marginTop: 'auto', marginBottom: '0', paddingRight: '15px', height: heightToSet }}
      type={type ? type : undefined}
      label={label}
      maxRows={rows ? rows : undefined}
      multiline={rows ? true : undefined}
      placeholder={label}
      error={touched && invalid}
      helperText={touched && error}
      {...input}
      {...custom}
      value={valueToSet ? valueToSet : undefined}
      InputLabelProps={{ className: inputLabelClass }}
      InputProps={{
        root: newInputProps,
        inputProps: newInputProps,
        className: (inputClass) ? inputClass : undefined,
        classes: {
          root: classToRoot ? classToRoot : undefined,
          input: classToInput ? classToInput : undefined,
        },
        startAdornment: startAdornment,
        endAdornment: endAdornment,
        disableUnderline: disableUnderline
      }}
    />
  )
};


export const renderPasswordField = ({
  label,
  input,
  inputClass,
  showPassword,
  meta: { touched, invalid, error },
  ...custom
}) => (
  <TextField
    style={{ width: '100%', marginLeft: 'auto', marginRight: 'auto', marginTop: 'auto', marginBottom: '0', paddingRight: '15px' }}
    label={label}
    placeholder={label}
    error={touched && invalid}
    helperText={touched && error}
    type={!showPassword ? "password" : ""}
    {...input}
    {...custom}
    InputProps={{
      classes: {
        input: inputClass,
      },
    }}
  />
)

export const renderThumbnailSelect = ({
  showStartAdornment = false,
  filterOptions = createFilterOptions({
    limit: 100
  }),
  label,
  open,
  onOpen,
  input,
  onChangeHandler,
  optionsItemsIconsData,
  selected,
  disabled,
  inputLabelClass = undefined,
  inputClass = undefined,
  autoCompleteStyles = {},
  meta: { touched, invalid, error },
  idToSet,
  ...custom
}) => {

  const styles = {
    autoComplete: {
      width: '100%',
      marginLeft: 'auto',
      marginRight: 'auto',
      marginTop: 'auto',
      marginBottom: '0',
      paddingRight: '15px',
      color: '#949494'
    },
    optionSelected: {
      marginBottom: '0',
      marginTop: '0',
      marginLeft: '10px'
    }
  }
  return (
    <Fragment>
      <Autocomplete
        open={open}
        autoSelect
        style={{ ...styles.autoComplete, ...autoCompleteStyles }}
        id={idToSet ? idToSet : 'renderThumbnailSelect'}
        options={optionsItemsIconsData}
        defaultValue={selected}
        value={selected}
        filterOptions={filterOptions}
        disabled={disabled ? disabled : false}
        getOptionSelected={(option, value) => option === value ? true : false}
        getOptionLabel={option => option.name ? option.name : ''}
        renderOption={option => {
          const color = option.categoryColor ? option.categoryColor : undefined;
          return (
            <Fragment>
              {
                option.iconUrl ?
                  <Icon style={{ fontSize: 30, width: '45px', height: '45px' }}>
                    {renderCorrectIcon(option)}
                  </Icon>
                  :
                  undefined
              }
              <p style={{ marginBottom: '0', marginTop: '0', marginLeft: '10px', fontWeight: 'bold', color: color, fontFamily: 'Gotham-Bold', fontSize: '22px' }}>{option.name}</p>
            </Fragment>
          )
        }}
        clearOnEscape={true}
        onChange={onChangeHandler}
        renderInput={(params) => {

          let newInputProps = params.InputProps ? params.InputProps : {}

          if (selected && (showStartAdornment && selected.iconUrl)) {

            const startAdornment = (
              <InputAdornment position="start">
                <Icon style={{ fontSize: 20, width: '25px', height: '25px' }}>
                  {renderCorrectIcon(selected)}
                </Icon>
              </InputAdornment>
            );

            newInputProps.startAdornment = startAdornment;
          }

          const endAdornment = (
            <InputAdornment position="end">
              {
                (selected != null && selected?.name !== '' && selected.name?.length > 0) ?
                  <IconButton onClick={() => { onChangeHandler(null, { name: '' }) }} color="white">
                    <ClearIcon style={{ color: 'white' }} fontSize="small" />
                  </IconButton> : ""
              }
              {
                (open === true) ?
                  <ExpandLessIcon style={{ color: 'white', cursor: 'pointer' }} />
                  :
                  <ExpandMoreIcon style={{ color: 'white', cursor: 'pointer' }} />
              }
            </InputAdornment>
          );
          newInputProps.endAdornment = endAdornment;

          newInputProps.className = "categoryDropDown fontColor";

          let inputColorSyle = params.inputProps ? params.inputProps : {}

          if (selected != null) {
            inputColorSyle.value = inputColorSyle.value !== "" ? inputColorSyle.value : selected !== undefined ? selected.name : "";
            inputColorSyle.style = { color: (selected && selected.categoryColor) ? selected.categoryColor : 'white' }
          }

          let newParams = { ...params, ...newInputProps, ...inputColorSyle }

          return (<Fragment>
            <TextField
              {...newParams}
              label={label}
              error={touched && invalid}
              helperText={touched && error}
              {...input}
              {...custom}
              InputLabelProps={{ className: inputLabelClass }}

            />
          </Fragment>
          )
        }
        }
      />
    </Fragment>
  );
};

export const renderSelect = ({
  showStartAdornment = false,
  filterOptions = createFilterOptions({
    limit: 100
  }),
  label,
  open,
  input,
  onChangeHandler,
  onCloseHandler,
  optionsItemsIconsData,
  selected,
  disabled = false,
  inputLabelClass = undefined,
  inputClass = undefined,
  autoCompleteStyles = {},
  idToSet = undefined,
  onBlur = undefined,
  diableClear = false,
  meta: { touched, invalid, error },
  ...custom
}) => {


  const styles = {
    autoComplete: {
      width: '100%',
      marginLeft: 'auto',
      marginRight: 'auto',
      marginTop: 'auto',
      marginBottom: '0',
      paddingRight: '15px'
    },
    optionSelected: {
      marginBottom: '0',
      marginTop: '0',
      marginLeft: '10px'
    }
  }

  return (
    <Fragment>
      <Autocomplete
        id={idToSet ? idToSet : 'combo-box-demo'}
        open={open}
        style={{ ...styles.autoComplete, ...autoCompleteStyles }}
        options={optionsItemsIconsData}
        defaultValue={selected}
        error={touched && invalid}
        helperText={touched && error}
        filterOptions={filterOptions}
        onBlur={onBlur ? onBlur : undefined}
        getOptionSelected={(option, value) => option === value ? true : false}
        getOptionLabel={option => option.name ? option.name : ''}
        renderOption={option => {
          const color = option.categoryColor ? option.categoryColor : undefined;

          const badgeStyle = {
            width: '25px',
            height: '25px',
            fontSize: '14px',
            marginRight: '1rem',
            borderRadius: '50%',
            backgroundColor: color,
            fontWeight: 'bold',
            color: 'white'
          }
          return (
            <Fragment>
              {
                option.iconUrl ?
                  <Grid item container justify='center' alignItems='center' style={{ ...badgeStyle, alignItems: 'center' }}>
                    {GetCategoryBadge(option.name)}
                  </Grid>
                  :
                  undefined
              }
              <p style={{ marginBottom: '0', marginTop: '0', marginLeft: '10px', fontWeight: 'bold', color: color, fontFamily: 'Gotham-Bold', fontSize: '22px' }}
                id={idToSet ? idToSet + option.name : 'combo-box-demo' + option.name}
              >
                {option.name}
              </p>
            </Fragment>
          )
        }}
        clearOnEscape
        onChange={onChangeHandler}
        onClose={onCloseHandler}
        value={selected}
        renderInput={(params) => {

          let newInputProps = params.InputProps ? params.InputProps : {}

          if (selected && (showStartAdornment && selected.iconUrl)) {

            /*
            const startAdornment=(
                                <InputAdornment position="start">
                                  <Icon style={{ fontSize: 20, width:'20px', height:'20px'}}>
                                    {renderCorrectIcon(selected)}
                                  </Icon>
                                </InputAdornment>
                                );
            */

            const badgeStyle = {
              width: '25px',
              height: '25px',
              fontSize: '14px',
              marginRight: '1rem',
              borderRadius: '50%',
              backgroundColor: selected.categoryColor,
              fontWeight: 'bold',
              color: 'white'
            };

            const startAdornment = (

              <InputAdornment position="start">
                <Grid item container justify='center' alignItems='center' style={{ ...badgeStyle, alignItems: 'center' }}>
                  {GetCategoryBadge(selected.name)}
                </Grid>
              </InputAdornment>
            );


            newInputProps.startAdornment = startAdornment;
          }
          const endAdornment = (
            <InputAdornment position="end" >
              {
                (!diableClear && selected != null && selected?.name !== '' && selected.name?.length > 0) ?
                  <IconButton onClick={() => { onChangeHandler(null, { name: '' }) }}>
                    <ClearIcon style={{ color: 'white' }} fontSize="small" />
                  </IconButton> : ""
              }
              {
                (open === true) ?
                  <ExpandLessIcon style={{ color: 'white', cursor: 'pointer' }} />
                  :
                  <ExpandMoreIcon style={{ color: 'white', cursor: 'pointer' }} />
              }
            </InputAdornment>
          );

          newInputProps.endAdornment = endAdornment;

          newInputProps.className = " categoryDropDown";

          let inputColorSyle = params.inputProps ? params.inputProps : {}

          if (selected != null) {
            inputColorSyle.value = inputColorSyle.value !== "" ? inputColorSyle.value : selected !== undefined ? selected.name : "";
            inputColorSyle.style = { color: (selected && selected.categoryColor) ? selected.categoryColor : 'white' }
          }
          const newParams = { ...params, newInputProps, ...inputColorSyle };

          return (<Fragment>
            <TextField
              {...newParams}
              label={label}
              error={touched && invalid}
              helperText={touched && error}
              {...input}
              {...custom}
              InputLabelProps={{ className: inputLabelClass }}
              value={selected}

            />
          </Fragment>
          )

        }}
        disabled={disabled ? disabled : false}
      />
    </Fragment>
  );
};

export const renderSelectV2 = ({
  showStartAdornment = false,
  filterOptions = createFilterOptions({
    limit: 100
  }),
  label,
  open,
  input,
  onChangeHandler,
  onCloseHandler,
  optionsItemsIconsData,
  selected,
  disabled = false,
  inputLabelClass = undefined,
  inputClass = undefined,
  autoCompleteStyles = {},
  idToSet = undefined,
  onBlur = undefined,
  diableClear = false,
  meta: { touched, invalid, error },
  ...custom
}) => {


  const styles = {
    autoComplete: {
      width: '100%',
      marginLeft: 'auto',
      marginRight: 'auto',
      marginTop: 'auto',
      marginBottom: '0',
      paddingRight: '15px'
    },
    optionSelected: {
      marginBottom: '0',
      marginTop: '0',
      marginLeft: '10px'
    }
  }

  return (
    <Fragment>
      <Autocomplete
        id={idToSet ? idToSet : 'combo-box-demo'}
        open={open}
        style={{ ...styles.autoComplete, ...autoCompleteStyles }}
        options={optionsItemsIconsData}
        defaultValue={selected}
        error={touched && invalid}
        helperText={touched && error}
        filterOptions={filterOptions}
        onBlur={onBlur ? onBlur : undefined}
        getOptionSelected={(option, value) => option === value ? true : false}
        getOptionLabel={option => option.name ? option.name : ''}
        renderOption={option => {
          const color = option.categoryColor ? option.categoryColor : undefined;

          const badgeStyle = {
            width: '25px',
            height: '25px',
            fontSize: '14px',
            marginRight: '1rem',
            borderRadius: '50%',
            backgroundColor: color,
            fontWeight: 'bold',
            color: 'white'
          }
          return (
            <Fragment>
              {
                option.iconUrl ?
                  <Grid item container justify='center' alignItems='center' style={{ ...badgeStyle, alignItems: 'center' }}>
                    {GetCategoryBadge(option.name)}
                  </Grid>
                  :
                  undefined
              }
              <p style={{ marginBottom: '0', marginTop: '0', marginLeft: '10px', fontWeight: 'bold', color: color, fontFamily: 'Gotham-Bold', fontSize: '22px' }}
                id={idToSet ? idToSet + option.name : 'combo-box-demo' + option.name}
              >
                {option.name}
              </p>
            </Fragment>
          )
        }}
        clearOnEscape
        onChange={onChangeHandler}
        onClose={onCloseHandler}
        value={selected}
        closeIcon={
          (!diableClear && selected != null && selected?.name !== '' && selected.name?.length > 0) ?
            <IconButton onClick={() => { onChangeHandler(null, { name: '' }) }}>
              <ClearIcon style={{ color: 'white' }} fontSize="small" />
            </IconButton> : ""
        }
        popupIcon={
          (open === true) ?
            <ExpandLessIcon style={{ color: 'white', cursor: 'pointer' }} />
            :
            <ExpandMoreIcon style={{ color: 'white', cursor: 'pointer' }} />
        }

        renderInput={(params) => {
          return (<Fragment>
            <TextField
              {...params}
              label={label}
              error={touched && invalid}
              helperText={touched && error}
              {...input}
              {...custom}
              InputLabelProps={{ className: inputLabelClass }}
              value={selected}
            />
          </Fragment>
          )

        }}
        disabled={disabled ? disabled : false}
      />
    </Fragment>
  );
};

export const LegacyRenderSelectV2 = ({
  showStartAdornment = false,
  filterOptions = createFilterOptions({
    limit: 100
  }),
  label,
  open,
  input,
  onChangeHandler,
  onCloseHandler,
  optionsItemsIconsData,
  selected,
  disabled = false,
  inputLabelClass = undefined,
  inputClass = undefined,
  autoCompleteStyles = {},
  idToSet = undefined,
  onBlur = undefined,
  diableClear = false,
  meta: { touched, invalid, error },
  ...custom
}) => {


  const styles = {
    autoComplete: {
      width: '100%',
      marginLeft: 'auto',
      marginRight: 'auto',
      marginTop: 'auto',
      marginBottom: '0',
      paddingRight: '15px'
    },
    optionSelected: {
      marginBottom: '0',
      marginTop: '0',
      marginLeft: '10px'
    }
  }

  return (
    <Fragment>
      <Autocomplete
        id={idToSet ? idToSet : 'combo-box-demo'}
        open={open}
        style={{ ...styles.autoComplete, ...autoCompleteStyles }}
        options={optionsItemsIconsData}
        defaultValue={selected}
        error={touched && invalid}
        helperText={touched && error}
        filterOptions={filterOptions}
        onBlur={onBlur ? onBlur : undefined}
        getOptionSelected={(option, value) => option === value ? true : false}
        getOptionLabel={option => option.name ? option.name : ''}
        classes={{
          option: "LMuiAutocomplete-option-community",
          listbox: "LMuiAutocomplete-listbox"
        }}
        renderOption={option => {
          const color = option.categoryColor ? option.categoryColor : undefined;

          const badgeStyle = {
            width: '25px',
            height: '25px',
            fontSize: '14px',
            marginRight: '1rem',
            borderRadius: '50%',
            backgroundColor: color,
            fontWeight: 'bold',
            color: 'white'
          }
          return (
            <Fragment>
              {
                option.iconUrl ?
                  <Grid item container justify='center' alignItems='center' style={{ ...badgeStyle, alignItems: 'center' }}>
                    {GetCategoryBadge(option.name)}
                  </Grid>
                  :
                  undefined
              }
              <p style={{ marginBottom: '0', marginTop: '0', marginLeft: '10px', fontWeight: 'bold', color: color, fontFamily: 'Gotham-Bold', fontSize: '22px' }}
                id={idToSet ? idToSet + option.name : 'combo-box-demo' + option.name}
              >
                {option.name}
              </p>
            </Fragment>
          )
        }}
        clearOnEscape
        onChange={onChangeHandler}
        onClose={onCloseHandler}
        value={selected}
        closeIcon={
          (!diableClear && selected != null && selected?.name !== '' && selected.name?.length > 0) ?
            <IconButton onClick={() => { onChangeHandler(null, { name: '' }) }}>
              <ClearIcon style={{ color: 'gray' }} fontSize="small" />
            </IconButton> : ""
        }
        popupIcon={
          (open === true) ?
            <ExpandLessIcon style={{ color: 'gray', cursor: 'pointer' }} />
            :
            <ExpandMoreIcon style={{ color: 'gray', cursor: 'pointer' }} />
        }

        renderInput={(params) => {
          return (<Fragment>
            <TextField
              {...params}
              label={label}
              error={touched && invalid}
              helperText={touched && error}
              {...input}
              {...custom}
              InputLabelProps={{ className: inputLabelClass }}
              value={selected}
            />
          </Fragment>
          )

        }}
        disabled={disabled ? disabled : false}
      />
    </Fragment>
  );
};

const GetCategoryBadge = (categoryName) => {
  let categoryWords = categoryName.split(' ');

  categoryWords = categoryWords.filter(item => item !== '&');

  const CategoryBadge = categoryWords.map(word => word.charAt(0).toUpperCase()).join('').slice(0, 2);

  return CategoryBadge;
};


export const CloseRequest = () => (
  <div>
    Este es el componente de details
  </div>
);


export const renderImage = (image) => {

  let icon = undefined;
  if (image && image.iconUrl && image.iconUrl.length > 0) {
    if (validator.isURL(image.iconUrl)) {
      icon = <img
        height='40px'
        src={image.iconUrl}
        alt={image.name}
      />
    } else {
      icon = <FontAwesomeIcon
        className="icon-menu-size"
        height='40px'

      />
    }
  } else {
    //default
    icon = <FontAwesomeIcon
      className="icon-menu-size"
      height='40px'
    />
  }

  return icon;
};
export const renderLegacyImage = (image) => {

  let icon = undefined;
  if (image && image.iconUrl && image.iconUrl.length > 0) {
    if (validator.isURL(image.iconUrl)) {
      icon = <img
        height='40px'
        src={image.iconUrl}
        alt={image.name}
        className='logo-black'
      />
    } else {
      icon = <FontAwesomeIcon
        className="icon-menu-size logo-black"
        height='40px'

      />
    }
  } else {
    //default
    icon = <FontAwesomeIcon
      className="icon-menu-size logo-black"
      height='40px'
    />
  }

  return icon;
};


export const renderTextFieldWithChips = ({
  chipsOptions,
  handlerOnChipDelete,
  handlerOnClickAddButton,
  label,
  value,
  input,
  onChange,
  selected,
  onKeyDown,
  inputClass,
  idToSet = undefined,
  meta: { touched, invalid, error },
  ...custom
}) => {
  return (
    <Fragment >
      <div style={{ marginTop: '5px', width: '100%' }}>
        <Grid container >
          {
            chipsOptions && Array.isArray(chipsOptions) && chipsOptions.length > 0 ?
              <Grid item container className={'smallContent'}>{label}</Grid>
              :
              undefined
          }
          <Grid item style={{ textAlign: 'left' }}>
            {
              chipsOptions.map((item, index) => {
                return (
                  <Chip
                    className="chipStyles"
                    key={'chip' + index}
                    size='large'
                    deleteIcon={<ClearIcon style={{ color: '#f0efef', opacity: '56%' }} />}
                    label={item}
                    onDelete={() => handlerOnChipDelete(item)}
                  />
                )
              })
            }
          </Grid>
          <Grid item container xs={12} style={{ marginTop: '.4rem', paddingRight: '15px' }}>
            <TextField
              id={idToSet ? idToSet : 'textfield_chips'}
              onChange={onChange}
              label={chipsOptions && Array.isArray(chipsOptions) && chipsOptions.length > 0 ? undefined : label}
              value={value}
              onKeyDown={onKeyDown}
              style={{ width: '100%' }}
              error={touched && invalid}
              helperText={touched && error}
              {...input}
              {...custom}
              InputProps={{
                classes: {
                  input: inputClass,
                },
              }}
            />
          </Grid>
          {/* <Grid item xs={2}>
      <Button
        onClick={handlerOnClickAddButton}
      >
        <AddIcon/>
      </Button>
    </Grid> */}
        </Grid>
      </div>
    </Fragment>
  );
};

export const TimePicker = (
  {
    label,
    defaultValue,
    input,
    meta: { touched, invalid, error },
    ...custom
  }) => {
  return (
    <TextField
      label={label}
      type='time'
      style={{ width: '100%', paddingRight: '15px' }}
      InputLabelProps={{
        shrink: true,
      }
      }
      inputProps={{
        step: 300, // 5 min
      }}
      {...input}
    />
  );
};


export const SimpleCard = (
  {
    shwowDateRegistration = false,
    resident,
    handlerClick,
    idToSet
  }
) => {

  let registrationYear = '';
  let registrationMonth = '';
  let registrationDay = '';

  const date = resident.updatedAt ? new Date(resident.updatedAt) : undefined;

  const zoneName = resident.zoneName ? resident.zoneName : undefined;
  let registed = date ? ((date.getMonth() + 1)) + '/' + (date.getDate()) : 'today'

  if (date) {
    registrationYear = date.getFullYear();
    registrationMonth = date.getMonth();
    registrationDay = date.getDate();

    if (
      registrationYear > 0 &&
      registrationDay > 0 &&
      registrationMonth > 0
    ) {
      const today = new Date();
      if (
        registrationYear === today.getFullYear() &&
        registrationMonth === today.getMonth() &&
        registrationDay === today.getDate()

      ) {
        registed = 'Today';
      }
    }
  }

  // date? `${date.getMonth()+1}\\${date.getDate()}\\${date.getFullYear()}` : 'Today';
  const name = resident.name ? resident.name : (resident.firstName && resident.lastName) ? resident.firstName + ' ' + resident.lastName : 'undefined';
  const inital = resident.firstName ? resident.firstName.substring(0, 1) + resident.lastName.substring(0, 1) : name.split(' ')[0].substring(0, 1) + name.split(' ')[1].substring(0, 1);
  const image = (resident.pictureUrl && resident.pictureUrl !== '') ? resident.pictureUrl : 'https://engage360.s3.amazonaws.com/Residents/profile.png';


  const className = (!zoneName && registed) ? 'ResidentCard' : 'ResidentCard pointer'

  return (
    <Grid item container id={idToSet ? idToSet : 'residentCard'} style={{ textAlign: 'center' }}>
      <Card className={className}>
        <CardContent className="heigh100" onClick={handlerClick ? () => handlerClick(resident) : undefined}>
          <Grid content className="heigh100">
            <Grid item container className="heigh60 alingCenter">
              {
                (!resident.pictureUrl || resident.pictureUrl === 'https://engage360.s3.amazonaws.com/Residents/profile.png') ?
                  <Grid item className="ResidentCardInitial ResidentCardImage">
                    {inital}
                  </Grid>
                  :
                  <Grid item container xs={12} className="alingCenter">
                    <Grid item className="alingCenter">
                      <img
                        src={image}
                        alt={'resident picture ' + resident.name}
                        className="ResidentCardImage"
                      />
                    </Grid>
                  </Grid>
              }
            </Grid>
            <Grid className="ResidentCardName alingCenter">
              {(name) ? (((name).length > 16) ? (name).slice(0, 14) + '...' : (name)) : 'no name'}
            </Grid>

            <Grid item container className="heigh20 alingCenter">
              {
                zoneName ?
                  <Grid item xs={12} className="ResidentCardLocation">
                    {(zoneName) ? ((zoneName.length > 16) ? zoneName.slice(0, 14) + '...' : zoneName) : 'no location'}
                  </Grid>
                  :
                  (!zoneName && registed) ?
                    <Grid item xs={12} className="ResidentCardLocation">
                      {'Registered ' + registed}
                    </Grid>
                    :
                    undefined
              }
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Grid>
  );
};

//#region DatePicker
export const renderSingleDatePicker = ({
  selectedDate,
  onDateChange,
  labelDate,
  minDate = undefined,
  disabled = false,
  meta: { touched, invalid, error },
  idToSet = undefined,
  inputClass = undefined,
  ...custom
}) => {
  const clickHandler = () => {
    try {
      //calendar header
      const calendarHeader = document.getElementsByClassName('MuiPickersCalendarHeader-switchHeader');

      if (calendarHeader && calendarHeader.length === 1) {
        const buttons = calendarHeader[0].getElementsByTagName('button');
        const header = calendarHeader[0].getElementsByTagName('div');

        if (buttons && buttons.length === 2) {
          buttons[0].setAttribute('id', 'calendarHeader_leftArrow');
          buttons[0].setAttribute('onclick', () => setTimeout(() => {
            clickHandler();
          }, 100));
          buttons[1].setAttribute('id', 'calendarHeader_rightArrow');
          buttons[1].setAttribute('onclick', () => setTimeout(() => {
            clickHandler();
          }, 100));
        }

        if (header && header.length === 1) {
          header[0].setAttribute('id', 'calendarHeader_header');
        }
      }

      //Week days
      const weeksElements = document.getElementsByClassName('MuiPickersCalendar-week');

      for (let i = 0; i < weeksElements.length; i++) {
        const thisweekelement = weeksElements[i];
        const thisWeekDaysElements = thisweekelement.getElementsByTagName('button');

        for (let j = 0; j < thisWeekDaysElements.length; j++) {

          for (let x = 0; x < thisWeekDaysElements.length; x++) {
            const thisWeekPElement = thisWeekDaysElements[x];
            const pContentElement = thisWeekPElement.getElementsByTagName('p');

            if (pContentElement && pContentElement.length === 1) {
              const content = pContentElement[0].textContent;

              pContentElement[0].setAttribute('id', `Calendar_Icon_Adornment_${content}`);
            }
          }
        }
      };

    } catch (err) { }
  }

  const calendarButton =
    <IconButton id={`Calendar_Btn_${labelDate ? labelDate.replace(' ', '') : undefined}_${idToSet ? idToSet : undefined}`}
      style={{ padding: 'none' }}
      className='calendarPadding'
      onClick={() => setTimeout(() => {
        clickHandler();
      }, 150)}
    >
      <InputAdornment position="end" >
        <Event className='activeAdornment' />
      </InputAdornment>
    </IconButton>

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <Grid container style={{ width: '100%' }}>
        <Grid item xs={12} sm={12} style={{ width: '100%', paddingRight: '15px' }} id={idToSet ? `${idToSet}_container` : "idDatePicker_container"}>
          <KeyboardDatePicker
            autoOk={true}
            disableToolbar
            disabled={disabled}
            disablePast
            minDate={minDate ? minDate : undefined}
            style={{ width: '100%' }}
            variant="inline"
            format="MM/dd/yyyy"
            margin="normal"
            id={idToSet ? idToSet : "idDatePicker"}
            label={labelDate}
            value={selectedDate}
            onChange={(e, date) => onDateChange(e, labelDate)}
            error={touched && invalid}
            helperText={touched && error}
            KeyboardButtonProps={{
              'aria-label': 'change date',
            }}
            keyboardIcon={calendarButton}
            InputProps={{
              className: (inputClass) ? inputClass : undefined,
            }}
          />
        </Grid>
      </Grid>
    </MuiPickersUtilsProvider>
  );
};

export const renderSingleDateFormattedPicker = ({
  selectedDate,
  onDateChange,
  labelDate,
  fieldFocus,
  fieldBlur,
  dateFormat = 'MM/dd/yyyy',
  disabledDates = undefined,
  isFieldFocused,
  idToSet = undefined
}) => {

  const clickHandler = () => {
    try {
      //calendar header
      const calendarHeader = document.getElementsByClassName('MuiPickersCalendarHeader-switchHeader');

      if (calendarHeader && calendarHeader.length === 1) {
        const buttons = calendarHeader[0].getElementsByTagName('button');
        const header = calendarHeader[0].getElementsByTagName('div');

        if (buttons && buttons.length === 2) {
          buttons[0].setAttribute('id', 'calendarHeader_leftArrow');
          buttons[0].onclick = () => setTimeout(() => {
            clickHandler()
          }, 100);
          buttons[1].setAttribute('id', 'calendarHeader_rightArrow');
          buttons[1].onclick = () => setTimeout(() => {
            clickHandler()
          }, 100);

        }

        if (header && header.length === 1) {
          header[0].setAttribute('id', 'calendarHeader_header');
        }
      }

      //Week days
      const weeksElements = document.getElementsByClassName('MuiPickersCalendar-week');

      for (let i = 0; i < weeksElements.length; i++) {
        const thisweekelement = weeksElements[i];
        const thisWeekDaysElements = thisweekelement.getElementsByTagName('button');

        for (let j = 0; j < thisWeekDaysElements.length; j++) {

          for (let x = 0; x < thisWeekDaysElements.length; x++) {
            const thisWeekPElement = thisWeekDaysElements[x];
            const pContentElement = thisWeekPElement.getElementsByTagName('p');

            if (pContentElement && pContentElement.length === 1) {
              const content = pContentElement[0].textContent;

              pContentElement[0].setAttribute('id', `Calendar_Icon_Adornment_${content}`);
            }
          }
        }
      };

      //Header
      const headerElement = document.getElementsByClassName('MuiPickersDatePickerRoot-toolbar');
      if (headerElement) {
        const newHeaderElemet = headerElement[0];
        const headerBtns = newHeaderElemet.getElementsByTagName('button');
        if (headerBtns && headerBtns.length > 0) {
          const yearBtn = headerBtns[0];
          const spanElement = yearBtn.getElementsByTagName('span');
          if (spanElement && spanElement.length > 0) {
            const h6Element = spanElement[0].getElementsByTagName('h6');
            if (h6Element && h6Element.length > 0 && h6Element[0].textContent) {
              h6Element[0].setAttribute('id', `yearBtn_${h6Element[0].textContent}`)
              h6Element[0].onclick = () => setTimeout(() => {
                selectYearHandler()
              }, 100);


            }
          }
        }
      }

      //Actions Root
      const Actions_Btn = document.getElementsByClassName('MuiDialogActions-root');
      if (Actions_Btn && Actions_Btn.length > 0) {
        const actions = Actions_Btn[0];
        if (actions) {
          const buttons = actions.getElementsByTagName('button');
          if (buttons && buttons.length === 2) {
            buttons[0].setAttribute('id', 'calendar_Btn_CANCEL')
            buttons[1].setAttribute('id', 'calendar_Btn_OK')

          }
        }
      }

    } catch (err) { }
  }

  const selectYearHandler = () => {
    try {
      const yearsArray = document.getElementsByClassName('MuiPickersYearSelection-container');

      if (yearsArray && yearsArray.length > 0) {
        const divsInYearArray = yearsArray[0].getElementsByTagName('div');
        if (divsInYearArray && divsInYearArray.length > 0) {
          for (let i = 0; i < divsInYearArray.length; i++) {
            const div = divsInYearArray[i];
            if (div && div.textContent) {
              div.setAttribute('id', `yearList_${div.textContent}`)
              div.onclick = () => setTimeout(() => {
                clickHandler()
              }, 200);
            }
          }
        }
      }
    } catch (err) { }
  }

  const calendarButton =
    <IconButton id={`Calendar_Btn_${labelDate ? labelDate.replace(' ', '') : undefined}_${idToSet ? idToSet : undefined}`}
      style={{ padding: 'none' }}
      onClick={() => setTimeout(() => {
        clickHandler();
      }, 150)}
    >
      <InputAdornment position="end" >
        <Event className='activeAdornment' />
      </InputAdornment>
    </IconButton>


  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils} key='idDatePicker1' id="idDatePicker" >
      <Grid item container xs={12} sm={12} style={{ width: '100%', paddingRight: '10px' }} id={idToSet ? `${idToSet}_Container` : "datePicker_Container"}>
        <KeyboardDatePicker
          onFocus={fieldFocus}
          id={idToSet ? idToSet : "datePicker"}
          onBlur={fieldBlur}
          placeholder={dateFormat.toUpperCase() + ''}
          format={dateFormat}
          autoFocus={isFieldFocused}
          autoOk={true}
          style={{ width: '100%' }}
          margin="normal"
          label={labelDate}
          value={selectedDate ? selectedDate : null}
          minDate={(disabledDates && disabledDates.minDate) ? disabledDates.minDate : undefined}
          maxDate={(disabledDates && disabledDates.maxDate) ? disabledDates.maxDate : undefined}
          onChange={(e, date) => onDateChange(e, labelDate)}
          KeyboardButtonProps={{
            'aria-label': 'change date',
          }}
          keyboardIcon={calendarButton}
        />
      </Grid>
    </MuiPickersUtilsProvider>
  );
};

export const renderDatePicker = ({
  selectedDate,
  onDateChange,
  labelDate,
  labelTime
}) => {


  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <Grid container style={{ width: '100%' }}>
        <Grid item xs={12} sm={6} style={{ width: '100%', paddingRight: '10px' }}>
          <KeyboardDatePicker
            autoOk={true}
            disableToolbar
            style={{ width: '100%' }}
            variant="inline"
            format="MM/dd/yyyy"
            margin="normal"
            id="idDatePicker"
            label={labelDate}
            value={selectedDate}
            onChange={(e, date) => onDateChange(e, labelDate)}
            KeyboardButtonProps={{
              'aria-label': 'change date',
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6} style={{ width: '100%', paddingRight: '10px' }}>
          <KeyboardTimePicker
            style={{ width: '100%' }}
            margin="normal"
            id="time-picker"
            label={labelTime}
            value={selectedDate}
            onChange={(e, date) => onDateChange(e, labelTime)}
            KeyboardButtonProps={{
              'aria-label': 'change time',
            }}
          />
        </Grid>
      </Grid>
    </MuiPickersUtilsProvider>
  );
};

export const renderJustDatePicker = ({
  selectedDate,
  onDateChange,
  labelDate,
  disabledDates = undefined,
  active
}) => {

  const padding = 'mui-icon-btn-root'

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <Grid container style={{ width: '100%' }}>
        <Grid item xs={12} sm={12} style={{ width: '100%' }}>
          <KeyboardDatePicker
            autoOk={true}
            disableToolbar
            disablePast
            style={{ width: '100%' }}
            variant="inline"
            format="MM/dd/yyyy"
            margin="normal"
            id="idDatePicker"
            label={labelDate}
            value={selectedDate}
            minDate={(disabledDates && disabledDates.minDate) ? disabledDates.minDate : undefined}
            maxDate={(disabledDates && disabledDates.maxDate) ? disabledDates.maxDate : undefined}
            onChange={(e, date) => onDateChange(e, labelDate)}
            KeyboardButtonProps={{
              'aria-label': 'change date',
              className: padding
            }}
            InputAdornmentProps={{ position: "start" }}
            keyboardIcon={
              <Event className={active ? 'whiteText' : 'grey_color'} style={{ margin: '0px', padding: '0px' }} />
            }
          />
        </Grid>
      </Grid>
    </MuiPickersUtilsProvider>
  );
};

export const renderActivityDatePicker = ({
  selectedDate,
  onDateChange,
  labelDate,
  active,
  isLegacy = false
}) => {

  const padding = 'mui-icon-btn-root'

  const past = moment(new Date()).subtract(1, 'year');

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <Grid container style={{ width: '100%' }}>
        <Grid item xs={12} sm={12} style={{ width: '100%' }}>
          <KeyboardDatePicker
            autoOk={true}
            disableToolbar
            style={{ width: '100%' }}
            variant="inline"
            format="MM/dd/yyyy"
            margin="normal"
            id="idDatePicker"
            label={labelDate}
            value={selectedDate}
            minDate={new Date(past)}
            onChange={(e, date) => onDateChange(e, labelDate)}
            KeyboardButtonProps={{
              'aria-label': 'change date',
              className: padding
            }}
            InputAdornmentProps={{ position: "start" }}
            keyboardIcon={
              isLegacy ?
              <Event className={  active ? 'grey_color' : 'engageBlue'} style={{ margin: '0px', padding: '0px' }} />
              :
              <Event className={  active ? 'whiteText' : 'grey_color'} style={{ margin: '0px', padding: '0px' }} />
            }
          />
        </Grid>
      </Grid>
    </MuiPickersUtilsProvider>
  );
};

export const renderRepairDatePicker = ({
  selectedDate,
  onDateChange,
  labelDate,
  active,
}) => {

  const padding = 'mui-icon-btn-root'

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <Grid container style={{ width: '100%' }}>
        <Grid item xs={12} sm={12} style={{ width: '100%' }}>
          <KeyboardDatePicker
            autoOk={true}
            disableToolbar
            style={{ width: '100%' }}
            variant="inline"
            format="MM/dd/yyyy"
            margin="normal"
            id="idDatePicker"
            label={labelDate}
            value={selectedDate}
            disableFuture
            onChange={(e, date) => onDateChange(e, labelDate)}
            KeyboardButtonProps={{
              'aria-label': 'change date',
              className: padding
            }}
            InputAdornmentProps={{ position: "start" }}
            keyboardIcon={
              <Event className={active ? 'whiteText' : 'grey_color'} style={{ margin: '0px', padding: '0px' }} />
            }
          />
        </Grid>
      </Grid>
    </MuiPickersUtilsProvider>
  );
};


export const renderLegacyRepairDatePicker = ({
  selectedDate,
  onDateChange,
  labelDate,
  onChangeLabel,
  active,
  idToSet
}) => {

  const padding = 'mui-icon-btn-root'

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <Grid container style={{ width: '100%' }}>
        <Grid item xs={12} sm={12} style={{ width: '100%' }}>
          <KeyboardDatePicker
            autoOk={true}
            disableToolbar
            style={{ width: '100%' }}
            variant="inline"
            format="MM/dd/yyyy"
            margin="normal"
            id="idDatePicker"
            label={labelDate}
            value={selectedDate}
            disableFuture
            onChange={(e, date) => onDateChange(e, labelDate)}
            KeyboardButtonProps={{
              'aria-label': 'change date',
              className: padding
            }}
            InputAdornmentProps={{ position: "start" }}
            keyboardIcon={
              <Event className={!active ? 'txt_black' : 'whiteText'} style={{ margin: '0px', padding: '0px' }} />
            }
            inputProps={{
              className: !active ? 'txt_black' : 'whiteText'
            }}
            InputLabelProps={{
              className: !active ? 'txt_black' : 'whiteText'
            }}
          />
        </Grid>
      </Grid>
    </MuiPickersUtilsProvider>
  );
}



export const renderSingleDateStartAndEndHours = ({
  selectedStartDate,
  selectedEndDate,
  onDateChange,
  labelDate,
  labelStartTime,
  labelEndTime,
  fieldFocus,
  fieldBlur,
  isFieldFocused,
  dateFormat = 'MM/dd/yyyy',
  disabledDates = undefined,
  meta: { touched, error },
  idToSet = undefined,
}) => {

  let labelStart = labelStartTime ? labelStartTime : 'Start Hour';
  let labelEnd = labelEndTime ? labelEndTime : 'End Hour';

  //Identifiers
  const iDate = 'date';
  const iStartDate = 'startDate';
  const iEndDate = 'endDate';

  const clickHandler = () => {
    try {
      //calendar header
      const calendarHeader = document.getElementsByClassName('MuiPickersCalendarHeader-switchHeader');

      if (calendarHeader && calendarHeader.length === 1) {
        const buttons = calendarHeader[0].getElementsByTagName('button');
        const header = calendarHeader[0].getElementsByTagName('div');

        if (buttons && buttons.length === 2) {
          buttons[0].setAttribute('id', 'calendarHeader_leftArrow');
          buttons[0].onclick = () => setTimeout(() => {
            clickHandler()
          }, 100);
          buttons[1].setAttribute('id', 'calendarHeader_rightArrow');
          buttons[1].onclick = () => setTimeout(() => {
            clickHandler()
          }, 100);
        }

        if (header && header.length === 1) {
          header[0].setAttribute('id', 'calendarHeader_header');
        }
      }

      //Week days
      const weeksElements = document.getElementsByClassName('MuiPickersCalendar-week');

      for (let i = 0; i < weeksElements.length; i++) {
        const thisweekelement = weeksElements[i];
        const thisWeekDaysElements = thisweekelement.getElementsByTagName('button');

        for (let j = 0; j < thisWeekDaysElements.length; j++) {

          for (let x = 0; x < thisWeekDaysElements.length; x++) {
            const thisWeekPElement = thisWeekDaysElements[x];
            const pContentElement = thisWeekPElement.getElementsByTagName('p');

            if (pContentElement && pContentElement.length === 1) {
              const content = pContentElement[0].textContent;

              pContentElement[0].setAttribute('id', `Calendar_Icon_Adornment_${content}`);
            }
          }
        }
      };

    } catch (err) { }
  }

  const setIdToclockNumber = () => {
    try {

      const nodes = document.getElementsByClassName('MuiPickersClockNumber-clockNumber');
      const timeBtns = document.getElementsByClassName('MuiPickersTimePickerToolbar-hourMinuteLabel')[0].getElementsByClassName('MuiPickersToolbarButton-toolbarBtn');
      const hourBtn = timeBtns && timeBtns.length === 2 ? timeBtns[0] : undefined;
      const minBtn = timeBtns && timeBtns.length === 2 ? timeBtns[1] : undefined;
      const ampmSelection = document.getElementsByClassName('MuiPickersTimePickerToolbar-ampmSelection')[0].getElementsByClassName('MuiPickersToolbarButton-toolbarBtn')
      const amBtn = ampmSelection && ampmSelection.length === 2 ? ampmSelection[0] : undefined;
      const pmBtn = ampmSelection && ampmSelection.length === 2 ? ampmSelection[1] : undefined;

      const actionsBtns = document.getElementsByClassName('MuiDialogActions-root')

      if (actionsBtns && actionsBtns.length > 0) {
        const btns = actionsBtns[0].getElementsByTagName('button');
        if (btns && btns.length === 2) {
          btns[0].setAttribute('id', 'TimePicker_Btn_Cancel');
          btns[1].setAttribute('id', 'TimePicker_Btn_Ok');
        }
      }

      if (hourBtn)
        hourBtn.setAttribute('id', 'TimeBtn_Hour');

      if (minBtn)
        minBtn.setAttribute('id', 'TimeBtn_Minutes')

      if (amBtn)
        amBtn.setAttribute('id', 'TimeBtn_AM');

      if (pmBtn)
        pmBtn.setAttribute('id', 'TimeBtn_PM')

      for (let i = 0; i < nodes.length; i++) {
        const node = nodes[i];
        const content = node.textContent

        node.setAttribute('id', `ClockNumber_${content}`)

      }

    } catch (err) { }
  }


  const endAdornment =
    <IconButton id={idToSet ? `${idToSet}_clock_btn` : 'StartEndTimeClockBtn'} style={{ padding: 'none' }} onClick={() => setTimeout(() => {
      setIdToclockNumber()
    }, 100)}>
      <InputAdornment position="end">
        <FontAwesomeIcon
          icon={faClock}
          className='activeAdornment'
        />
      </InputAdornment>
    </IconButton>

  const endAdornmentEndDate =
    <IconButton id={idToSet ? `${idToSet}_clock_EndTime_btn` : 'StartEndTimeClockEndTimeBtn'} style={{ padding: 'none' }} onClick={() => setTimeout(() => {
      setIdToclockNumber()
    }, 100)}>
      <InputAdornment position="end">
        <FontAwesomeIcon
          icon={faClock}
          className='activeAdornment'
        />
      </InputAdornment>
    </IconButton>


  const calendarButton = <IconButton id={idToSet ? `${idToSet}_calendar_btn` : 'StartEndTimeCalendarBtn'} style={{ padding: 'none' }} onClick={() => setTimeout(() => {
    clickHandler()
  }, 100)}>
    <InputAdornment position="end" >
      <Event className='activeAdornment' />
    </InputAdornment>
  </IconButton>


  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils} key='idDatePicker1' id="idDatePicker" >
      <Grid container style={{ width: '100%' }} id={idToSet ? `${idToSet}_container` : 'StartEndTime_container'}>
        <Grid item xs={12} sm={12} style={{ width: '100%', paddingRight: '10px' }} id={idToSet ? `${idToSet}_date_container` : 'StartEndTime_date_container'}>
          <KeyboardDatePicker
            id={idToSet ? `${idToSet}_date` : 'StartEndTime_date'}
            onFocus={fieldFocus}
            onBlur={fieldBlur}
            placeholder={dateFormat.toUpperCase() + ''}
            format={dateFormat}
            minDate={(disabledDates && disabledDates.minDate) ? disabledDates.minDate : undefined}
            maxDate={(disabledDates && disabledDates.maxDate) ? disabledDates.maxDate : undefined}
            autoFocus={isFieldFocused}
            autoOk={true}
            disableToolbar
            disablePast
            style={{ width: '100%' }}
            // variant="inline"
            margin="normal"
            label={labelDate}
            value={selectedStartDate}
            onChange={(e, date) => onDateChange(e, iDate)}
            KeyboardButtonProps={{
              'aria-label': 'change date',
            }}
            keyboardIcon={calendarButton}
          />
        </Grid>
        <Grid item xs={12} sm={6} style={{ width: '100%', paddingRight: '10px' }} id={idToSet ? `${idToSet}_start_time_container` : 'StartEndTime_start_time_container'}>
          <KeyboardTimePicker
            style={{ width: '100%' }}
            margin="normal"
            id={idToSet ? `${idToSet}_start_time` : 'StartEndTime_start_time'}
            label={labelStart}
            keyboardIcon={endAdornment}
            value={selectedStartDate}
            onChange={(e, date) => onDateChange(e, iStartDate)}
            KeyboardButtonProps={{
              'aria-label': 'change time',
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6} style={{ width: '100%', paddingRight: '10px' }} id={idToSet ? `${idToSet}_end_time_container` : 'StartEndTime_end_time_container'}>
          <KeyboardTimePicker
            style={{ width: '100%' }}
            margin="normal"
            id={idToSet ? `${idToSet}_end_time` : 'StartEndTime_end_time'}
            keyboardIcon={endAdornmentEndDate}
            label={labelEnd}
            value={selectedEndDate}
            onChange={(e, date) => onDateChange(e, iEndDate)}
            KeyboardButtonProps={{
              'aria-label': 'change time',
            }}
          />
        </Grid>
        {
          touched &&
          <Grid className="errorText">
            {error}
          </Grid>
        }
      </Grid>
    </MuiPickersUtilsProvider>
  );
};


export const renderTimePicker = ({
  selectedDate,
  onDateChange,
  label,
  fieldName,
  inputClass,
  disabled = false,
  idToSet = undefined,
}) => {
  const endAdornment =
    <InputAdornment position="end">
      <FontAwesomeIcon
        icon={faClock}
        style={{ color: disabled ? '#171717' : '#009edd' }}
      />
    </InputAdornment>

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <Grid container style={{ width: '100%' }}>
        <Grid item xs={12} sm={12} style={{ width: '100%', paddingRight: '10px' }}>
          <KeyboardTimePicker
            style={{ width: '100%', fontSize: '7px' }}
            margin="normal"
            id={idToSet}
            InputProps={{
              classes: {
                input: inputClass,
              }
            }}
            keyboardIcon={endAdornment}
            label={label}
            disabled={disabled}
            value={selectedDate}
            onChange={(e, date) => onDateChange(e, fieldName)}
            KeyboardButtonProps={{
              'aria-label': 'change time',
            }}
          />
        </Grid>
      </Grid>
    </MuiPickersUtilsProvider>
  );
};
//#endregion

//#region SwitchWithLabel
export const renderSwitchWithLabel = ({
  labelInLeft = false,
  stylesLabel = {},
  checked,
  onClick,
  label,
  idToSet
}
) => {

  let classRoot = 'switchRoot';
  let classTrack = 'switchTrack';
  let classthumb = 'switchThumb';


  if (checked) {
    classthumb = 'switchThumbChecked';
    classTrack = 'switchTrackChecked';
  }

  return (
    <Grid id={idToSet ? idToSet + '_container' : 'switch_container'} item container alignItems='center' style={{ padding: '5px 0' }}>
      {
        !labelInLeft ?
          <Grid item container xs={8} sm={8} md={8} style={{ ...stylesLabel }} justify='flex-end' id={idToSet ? idToSet + '_label' : 'switch_label'}>
            <Grid item style={{ paddingRight: '10px' }}>
              {label ? label : ''}
            </Grid>
          </Grid>
          :
          undefined
      }
      <Grid item xs={4} sm={4} md={4}>
        <Switch
          id={idToSet ? idToSet : 'switch'}
          classes={{
            root: classRoot,
            thumb: classthumb,
            track: classTrack,
          }}
          checked={checked}
          onClick={onClick}>
        </Switch>
      </Grid>
      {
        labelInLeft ?
          <Grid item container xs={8} sm={8} md={8} style={{ ...stylesLabel }} justify='flex-start' id={idToSet ? idToSet + '_label' : 'switch_label'}>
            <Grid item style={{ paddingLeft: '10px' }}>
              {label ? label : ''}
            </Grid>
          </Grid>
          :
          undefined
      }

    </Grid>

  );
}
//#endregion

//Activity switch
export const renderActivitySwitch = ({
  stylesLabel = {},
  checked,
  onClick,
  label,
  idToSet
}
) => {

  let classRoot = 'activitySwitchRoot';
  let classTrack = 'switchTrack';
  let classthumb = 'activitySwitchThumb';


  if (checked) {
    classthumb = 'activitySwitchThumbChecked';
    classTrack = 'switchTrackChecked';
  }

  return (
    <Grid id={idToSet ? idToSet + '_container' : 'switch_container'} item container xs={12} alignItems='center' justifyContent='space-between' style={{ padding: '5px 0' }}>
      <Grid item md={6} lg={8} style={{ ...stylesLabel, paddingRight: '10px' }} id={idToSet ? idToSet + '_label' : 'switch_label'}>
        {label ? label : ''}
      </Grid>

      <Switch
        id={idToSet ? idToSet : 'switch'}
        classes={{
          root: classRoot,
          thumb: classthumb,
          track: classTrack,
        }}
        checked={checked}
        onClick={onClick}>
      </Switch>
    </Grid>

  );
}

//#region renderSwitchWeek
export const renderSwitchWeek = ({
  checked,
  onClick,
  label,
  disabled,
  idToSet = undefined
}
) => {

  const switchWeek = {
    basic: {
      paddingRight: '10px',
    },
    label: {
      color: 'white'
    }
  }

  return (
    <Grid item container justify='flex-start' style={{ ...switchWeek.basic, ...switchWeek.label }}>

      <Switch
        id={idToSet ? idToSet : 'Basic_Switch'}
        disabled={disabled}
        checked={checked}
        onClick={onClick} />
      {label}
    </Grid>

  );
}
//#endregion


//#region LoadImage

export const RenderImageLoaderCommunity = ({
  text = '',
  residentName,
  onChange,
  onClick,
  imageUrl,
  imageName,
  styleCardContentStyles = {},
  divTextStyles = {},
  styleInputFileStyles = {},
  imageStyles = {},
  innerCard = {},
  disabled = false,
  isCommunity = false,
}) => {

  let backSize = 'cover';

  if (imageUrl) {

    var img = document.createElement('img');
    img.src = imageUrl;
    if (img) {
      backSize = (img.width || img.height) > 300 ? '300px' : 'auto';
      backSize = (img.width) === 0 ? '300px' : backSize;
    }
  }
  const styles = {
    styleCardContent: {
      padding: '0px',
      position: 'relative',
      margin: 'auto',
      minHeight: '130px',
      backgroundColor: '#fff',
      backgroundImage: `url(${imageUrl})`,
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      borderRadius: '50%',
      backgroundSize: backSize,
    },
    styleInputFile: {
      top: 0,
      left: 0,
      position: 'absolute',
      width: '100%',
      height: '100%',
      opacity: '0.0',
      zIndex: '15'
    },
    image: {
      // width:'100%',
      height: '100%',
      marginLeft: 'auto',
      marginRight: 'auto',
    },
    divText: {
      position: 'absolute',
      //bottom:'-20px !important',
      //backgroundColor:'#2a2a2b',
      backgroundColor: 'rgb(69 68 70 / 78%)',
      //backgroundColor:'transparent',
      color: 'white',
      fontSize: '16px',
      padding: '14px',
      bottom: 0
    },
    IntialNameText: {
      position: 'absolute',
      backgroundColor: 'transparent',
      color: '#efeeee',
      fontSize: '90px',
      fontFamily: 'Gotham-Bold'
    },
    innercard: {
      width: '100%', height: '100%', position: 'relative'
    }
  }

  const image = imageUrl ? imageUrl
    : residentName !== undefined ? ''
      : 'https://engage360.s3.amazonaws.com/Activity/genericPictureSearch.png';



  return (
    <Grid item xs={12} style={{}} >
      <Grid id='community_communityLogo' item container xs={12} style={{ ...styles.styleCardContent, ...styleCardContentStyles, }} >
        <Grid item container xs={12} justify='center' alignItems='center' style={{ ...styles.innercard, ...innerCard }}>
          {
            (!(residentName === undefined) && image.length <= 1) ?
              <Grid item container xs={12} justify='center' alignItems='center' style={{ ...styles.IntialNameText }}> {residentName} </Grid> : undefined
          }
          <Grid item container xs={12} style={{ width: '100%', height: '100%', }} >
            {
              !disabled ?
                <input
                  className='divContentImageLoader'
                  accept="image/*"
                  multiple={false}
                  type="file"
                  onChange={onChange}
                  style={{ ...styles.styleInputFile, ...styleInputFileStyles }}
                />
                :
                undefined
            }
            {/* <img
                style={{...styles.image,...imageStyles}}
                src={image}
                alt={(imageUrl &&  imageUrl.length > 0) ?  imageName: ''}
              /> */}
          </Grid>
          {
            (image && image.length > 0) ?
              <Grid item container xs={12} >
                <Grid item container xs={12} justify='center' alignItems='center' style={{ ...styles.divText, ...divTextStyles, }}>{text}</Grid>
              </Grid>
              :
              undefined

          }
        </Grid>
      </Grid>
    </Grid>
  );
}

export const RenderImageLoader = ({
  text = '',
  residentName,
  onChange,
  onClick,
  imageUrl,
  imageName,
  styleCardContentStyles = {},
  divTextStyles = {},
  styleInputFileStyles = {},
  imageStyles = {},
  innerCard = {},
  disabled = false,
  isCommunity = false,
  idToSet = undefined,
}) => {


  const styles = {
    styleCardContent: {
      padding: '0px',
      position: 'relative',
      margin: 'auto',
      minHeight: '130px',

    },
    styleInputFile: {
      top: 0,
      left: 0,
      position: 'absolute',
      width: '100%',
      height: '100%',
      opacity: '0.0',
      zIndex: '15'
    },
    image: {
      width: '100%',
      height: '200px',
      objectFit: 'scale-down'
    },
    divText: {
      position: 'absolute',
      backgroundColor: '#1F1F1F',
      opacity: 0.87,
      fontSize: '18px',
      padding: '8px',
      bottom: 0
    },
    IntialNameText: {
      position: 'absolute',
      backgroundColor: 'transparent',
      color: '#F0EFEF',
      opacity: 0.56,
      fontSize: '90px',
      fontFamily: 'Gotham-Bold'
    },
    innercard: {
      width: '100%', height: '100%', position: 'relative'
    }
  }

  const image = imageUrl ? imageUrl
    : residentName !== undefined ? ''
      : 'https://engage360.s3.amazonaws.com/Activity/genericPictureSearch.png';

  return (
    <Grid item xs={12} style={{}} id={idToSet ? idToSet : 'renderImageLoader'}>
      <Grid item container xs={12} style={{ ...styles.styleCardContent, ...styleCardContentStyles, }} >
        <Grid item container xs={12} justify='center' alignItems='center' style={{ ...styles.innercard, ...innerCard }}>
          {
            (!(residentName === undefined) && image.length <= 1) ?
              <Grid item container xs={12} justify='center' alignItems='center' style={{ ...styles.IntialNameText }}> {residentName} </Grid> : undefined
          }
          <Grid item container xs={12} style={{ width: '100%', height: '100%', }} >
            {
              !disabled ?
                <input
                  className='divContentImageLoader'
                  accept="image/*"
                  multiple={false}
                  type="file"
                  onChange={onChange}
                  style={{ ...styles.styleInputFile, ...styleInputFileStyles }}
                />
                :
                undefined
            }
            <img
              style={{ ...styles.image, ...imageStyles, overflowX: 'hidden' }}
              src={image}
              alt={(imageUrl && imageUrl.length > 0) ? imageName : ''}
            />
          </Grid>
          {
            (image && image.length > 0) ?
              <Grid item container xs={12} >
                <Grid item container xs={12} justify='center' alignItems='center' style={{ ...styles.divText, ...divTextStyles, }}>{text}</Grid>
              </Grid>
              :
              undefined

          }
        </Grid>
      </Grid>
    </Grid>
  );
}

export const RenderImageLoaderMeal = ({
  text = '',
  residentName,
  onChange,
  onClick,
  imageUrl,
  imageName,
  styleCardContentStyles = {},
  divTextStyles = {},
  styleInputFileStyles = {},
  imageStyles = {},
  innerCard = {},
  disabled = false,
  isCommunity = false,
  idToSet = undefined,
}) => {


  const styles = {
    styleCardContent: {
      padding: '0px',
      position: 'relative',
      margin: 'auto',
      minHeight: '130px',

    },
    styleInputFile: {
      top: 0,
      left: 0,
      position: 'absolute',
      width: '100%',
      height: '100%',
      opacity: '0.0',
      zIndex: '15'
    },
    image: {
      width: '100%',
      paddingRight: '15px',
      objectFit: 'scale-down',
      maxHeight: '280px'
    },
    IntialNameText: {
      position: 'absolute',
      backgroundColor: 'transparent',
      color: '#F0EFEF',
      opacity: 0.56,
      fontSize: '90px',
      fontFamily: 'Gotham-Bold'
    },
    innercard: {
      width: '100%', height: '100%', position: 'relative'
    }
  }

  const image = imageUrl ? imageUrl
    : residentName !== undefined ? ''
      : 'https://engage360.s3.amazonaws.com/Activity/genericPictureSearch.png';

  return (
    <Grid item xs={12} style={{}} id={idToSet ? idToSet : 'renderImageLoader'}>
      <Grid item container xs={12} style={{ ...styles.styleCardContent, ...styleCardContentStyles, }} >
        <Grid item container xs={12} justify='center' alignItems='center' style={{ ...styles.innercard, ...innerCard }}>
          {
            (!(residentName === undefined) && image.length <= 1) ?
              <Grid item container xs={12} justify='center' alignItems='center' style={{ ...styles.IntialNameText }}> {residentName} </Grid> : undefined
          }
          <Grid item container xs={12} style={{ width: '100%', height: '100%', }} >
            {
              !disabled ?
                <input
                  className='divContentImageLoader'
                  accept="image/*"
                  multiple={false}
                  type="file"
                  onChange={onChange}
                  style={{ ...styles.styleInputFile, ...styleInputFileStyles }}
                />
                :
                undefined
            }
            <img
              style={{ ...styles.image, ...imageStyles, overflowX: 'hidden' }}
              src={image}
              alt={(imageUrl && imageUrl.length > 0) ? imageName : ''}
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}

export const RenderImageLoaderPortrait = ({
  text = '',
  onChange,
  onClick,
  imageUrl,
  imageName,
  styleCardContentStyles = {},
  divTextStyles = {},
  styleInputFileStyles = {},
  imageStyles = {},
  innerCard = {},
  isCommunity = false,
  idToSet = undefined,
  allowDeletion = false,
  deletionHandler = undefined,
}) => {


  if (imageUrl) {
    var img = document.createElement('img');
    img.src = imageUrl;
  }

  const styles = {
    styleCardContent: {
      padding: '0px',
      position: 'relative',
      margin: 'auto',
      height: '470px',
      backgroundImage: `url(${imageUrl})`,
      /*backgroundSize: backSize,*/
      backgroundSize: 'contain',
      backgroundPosition: 'center center',
      backgroundRepeat: 'no-repeat',
      cursor: 'pointer'
      /*borderRadius: '16px'*/
    },
    styleInputFile: {
      width: '100%',
      opacity: '0',
      zIndex: '15',
      height: 'inherit'
    },
    image: {
      width: '100%',
      height: '350px',
      objectFit: 'fill',
      position: 'absolute',
      top: '-100px',
      padding: '5px'
    },
    divText: {
      fontSize: '18px'
    },
    IntialNameText: {
      position: 'absolute',
      backgroundColor: 'transparent',
      color: '#F0EFEF',
      opacity: 0.56,
      fontSize: '90px',
      fontFamily: 'Gotham-Bold'
    },
    innercard: {
      width: '100%'
    }
  }

  return (
    <Grid item container xs={12} justify='center' alignContent='center' id={idToSet ? idToSet : 'renderImageLoader'} style={{ position: 'relative' }} >
      {
        (imageUrl && allowDeletion) ?
          <Grid item container xs={12} id='pinClearIcon' justify='flex-end' alignContent='flex-start' style={{ position: 'absolute', height: '100%' }}>
            <Grid item container xs={12} justify='flex-end' alignContent='center' style={{ padding: '10px', width: '45px', borderRadius: '50%', zIndex: '30', lineHeight: '15px' }}>
              <Grid item style={{ color: 'white', fontSize: '40px', fontWeight: 'bold' }} className='clearIconClass' onClick={() => deletionHandler()}> x </Grid>
            </Grid>
          </Grid>
          :
          undefined
      }
      <Grid item container xs={12} justify='center' alignContent='center' style={{ ...styles.styleCardContent, ...styleCardContentStyles }} >
        <Grid item container xs={12} justify='center' alignContent='center' alignItems='center' style={{ ...styles.innercard, ...innerCard }}>
          <Grid item container xs={12} justify='center' alignContent='center' style={{ height: '470px' }} >
            <input
              className='divContentImageLoader'
              accept="image/png, image/jpg, image/jpeg"
              multiple={false}
              type="file"
              onChange={onChange}
              onClick={
                (event) => {
                  event.target.value = ''
                }
              }
              style={{ ...styles.styleInputFile, ...styleInputFileStyles }}
            />
          </Grid>
          {
            !imageUrl ?
              <Grid item container xs={12} style={{ position: 'absolute' }}>
                <Grid item container xs={12} justify='center' alignContent='center' alignItems='center' style={{ ...styles.divText, ...divTextStyles, }}>
                  <Image className="pinTypeIconWhite" />
                </Grid>
                <Grid item container xs={12} justify='center' alignContent='center' alignItems='center' style={{ ...styles.divText, ...divTextStyles, }}>
                  {text}
                </Grid>
              </Grid>
              :
              undefined
          }
        </Grid>
      </Grid>
    </Grid>
  );
}

export const RenderImageLoaderLandscape = ({
  text = '',
  onChange,
  onClick,
  imageUrl,
  imageName,
  styleCardContentStyles = {},
  divTextStyles = {},
  styleInputFileStyles = {},
  imageStyles = {},
  innerCard = {},
  isCommunity = false,
  idToSet = undefined,
  allowDeletion = false,
  deletionHandler = undefined,
}) => {

  if (imageUrl) {
    var img = document.createElement('img');
    img.src = imageUrl;
  }

  const styles = {
    styleCardContent: {
      padding: '0px',
      position: 'relative',
      margin: 'auto',
      height: '210',
      backgroundImage: `url(${imageUrl})`,
      /*backgroundSize: backSize,*/
      backgroundSize: 'contain',
      backgroundPosition: 'center center',
      backgroundRepeat: 'no-repeat',
      cursor: 'pointer'
      /*borderRadius: '16px'*/
    },
    styleInputFile: {
      width: '100%',
      opacity: '0',
      zIndex: '15',
      height: 'inherit'
    },
    image: {
      width: '100%',
      height: '230px',
      position: 'absolute',
      top: '-55px'
    },
    divText: {
      fontSize: '18px'
    },
    IntialNameText: {
      position: 'absolute',
      backgroundColor: 'transparent',
      color: '#F0EFEF',
      opacity: 0.56,
      fontSize: '90px',
      fontFamily: 'Gotham-Bold'
    },
    innercard: {
      width: '100%'
    }
  }
  return (
    <Grid item container justify='center' alignContent='center' xs={12} id={idToSet ? idToSet : 'renderImageLoader'} style={{ position: 'relative' }}>
      {
        (imageUrl && allowDeletion) ?
          <Grid item container xs={12} id='pinClearIcon' justify='flex-end' alignContent='flex-start' style={{ position: 'absolute', height: '100%' }}>
            <Grid item container xs={12} justify='flex-end' alignContent='center' style={{ padding: '10px', width: '45px', borderRadius: '50%', zIndex: '30', lineHeight: '15px' }}>
              <Grid item style={{ color: 'white', fontSize: '40px', fontWeight: 'bold' }} className='clearIconClass' onClick={() => deletionHandler()}> x </Grid>
            </Grid>
          </Grid>
          :
          undefined
      }
      <Grid item container justify='center' alignContent='center' xs={12} style={{ ...styles.styleCardContent, ...styleCardContentStyles, }} >
        <Grid item container justify='center' alignContent='center' xs={12} alignItems='center' style={{ ...styles.innercard, ...innerCard }}>
          <Grid item container justify='center' alignContent='center' xs={12} style={{ height: '250px' }} >
            <input
              className='divContentImageLoader'
              accept="image/png, image/jpg, image/jpeg"
              multiple={false}
              type="file"
              onChange={onChange}
              onClick={
                (event) => {
                  event.target.value = ''
                }
              }
              style={{ ...styles.styleInputFile, ...styleInputFileStyles }}
            />
          </Grid>
          {
            !imageUrl ?
              <Grid item container xs={12} style={{ position: 'absolute' }}>
                <Grid item container xs={12} justify='center' alignItems='center' style={{ ...styles.divText, ...divTextStyles, }}>
                  <Image className="pinTypeIconWhite" />
                </Grid>
                <Grid item container xs={12} justify='center' alignItems='center' style={{ ...styles.divText, ...divTextStyles, }}>
                  {text}
                </Grid>
              </Grid>
              :
              undefined
          }
        </Grid>
      </Grid>
    </Grid>
  );
}

//#endregion


//#endregion


//#region  SimpleSelect
export const SimpleSelect = ({
  showStartAdornment = false,
  showLabel = false,
  label,
  input,
  onChangeHandler,
  optionsItemsIconsData,
  selected,
  disabled,
  error = undefined,
  helperText = undefined,
  open,
  onBlur,
  autoFocus,
  stylesObj = undefined,
  idToSet = undefined,
}) => {
  return (
    <Fragment>
      <Autocomplete
        id={idToSet ? idToSet : 'combo-box-demo'}
        open={open}
        freeSolo
        disableClearable
        style={{ width: '100%', marginLeft: 'auto', marginRight: 'auto', marginTop: 'auto', marginBottom: '0', paddingRight: '15px', }}
        options={optionsItemsIconsData}
        value={selected}
        disabled={disabled ? disabled : false}
        // InputProps={
        //   {
        //     underline:'noBorderStyle'
        // }}
        classes={{
          option: "MuiAutocomplete-option-community",
        }}
        getOptionSelected={(option, value) => option === value ? true : false}
        getOptionLabel={option => option.name ? option.name : ''}
        renderOption={option => {

          let startAdornment = undefined;

          if (option.categoryColor && showStartAdornment) {

            const badgeStyle = {
              width: '25px',
              height: '25px',
              fontSize: '14px',
              marginRight: '1rem',
              borderRadius: '50%',
              backgroundColor: option.categoryColor,
              fontWeight: 'bold',
              color: 'white'
            }

            startAdornment = (
              <Grid item container justify='center' alignItems='center' style={{ ...badgeStyle, alignItems: 'center' }}>
                {GetCategoryBadge(option.name)}
              </Grid>
            )
          }


          return (
            <Fragment>
              <Grid item container className={(!option.indexForCombo) ? "optionRow" : (option.indexForCombo % 2 === 0) ? "optionRow" : "optionRowEven"}>
                <Grid item>{startAdornment}</Grid>
                <Grid item style={{ color: (option.categoryColor && showStartAdornment) ? option.categoryColor : 'white' }}>{option.name}</Grid>
              </Grid>
            </Fragment>
          )
        }}
        clearOnEscape
        onChange={onChangeHandler}
        renderInput={(params) => {

          //Adornments
          let startAdornment = undefined;
          if (selected && selected.name && showStartAdornment) {
            const badgeStyle = {
              width: '25px',
              height: '25px',
              fontSize: '14px',
              marginRight: '1rem',
              borderRadius: '50%',
              backgroundColor: selected.categoryColor,
              fontWeight: 'bold',
              color: 'white'
            };


            startAdornment = (

              <InputAdornment position="start">
                <Grid item container justify='center' alignItems='center' style={{ ...badgeStyle, alignItems: 'center' }}>
                  {GetCategoryBadge(selected.name)}
                </Grid>
              </InputAdornment>
            );

          }

          let inputColorStyle = params.inputProps ? params.inputProps : {}
          inputColorStyle.style = { color: (selected && selected.categoryColor && showStartAdornment) ? selected.categoryColor : 'white' }

          const newParams = { ...params, ...inputColorStyle }

          //newInputProps
          const newInputProps = {
            ...newParams.InputProps,

            startAdornment: (
              <React.Fragment>
                {
                  startAdornment
                }

                {params.InputProps.startAdornment}
              </React.Fragment>
            ),
            endAdornment: (
              <React.Fragment>
                {
                  (open === true) ?
                    <ExpandLessIcon id={idToSet ? `${idToSet}_close_btn` : 'dropdown_close_btn'} style={{ color: 'white', cursor: 'pointer' }} />
                    :
                    <ExpandMoreIcon id={idToSet ? `${idToSet}_open_btn` : 'dropdown_open_btn'} style={{ color: 'white', cursor: 'pointer' }} />
                }

                {params.InputProps.endAdornment}
              </React.Fragment>
            ),
            classes: { ...stylesObj }
          }


          return (

            <Fragment>
              <TextField
                {...newParams}
                {...input}
                error={error ? error : undefined}
                helperText={helperText ? helperText : undefined}
                //style={{backgroundColor:(open)?'#1f1f1f':'transparent'}}
                onBlur={onBlur}
                autoFocus={autoFocus}
                label={showLabel ? label : undefined}
                InputProps={{ ...newInputProps }}

              />

            </Fragment>
          )
        }
        }
      />
    </Fragment>
  );
};


export const SimpleSelectV2 = ({
  showStartAdornment = false,
  showLabel = false,
  label,
  input,
  onChangeHandler,
  optionsItemsIconsData,
  selected,
  disabled,
  error = undefined,
  helperText = undefined,
  open,
  onBlur,
  autoFocus,
  stylesObj = undefined,
  idToSet = undefined,
}) => {
  return (
    <Fragment>
      <Autocomplete
        id={idToSet ? idToSet : 'combo-box-demo'}
        open={open}
        freeSolo
        disableClearable
        style={{ width: '100%', marginLeft: 'auto', marginRight: 'auto', marginTop: 'auto', marginBottom: '0', paddingRight: '15px', }}
        options={optionsItemsIconsData}
        value={selected}
        disabled={disabled ? disabled : false}
        // InputProps={
        //   {
        //     underline:'noBorderStyle'
        // }}
        classes={{
          option: "MuiAutocomplete-option-community",
        }}
        getOptionSelected={(option, value) => option === value ? true : false}
        getOptionLabel={option => option.name ? option.name : ''}
        renderOption={option => {

          return (
            <Fragment>
              <Grid item container className={(!option.indexForCombo) ? "optionRow" : (option.indexForCombo % 2 === 0) ? "optionRow" : "optionRowEven"}>
                <Grid item style={{ color: 'black' }}>{option.name}</Grid>
              </Grid>
            </Fragment>
          )
        }}
        clearOnEscape
        onChange={onChangeHandler}
        renderInput={(params) => {

          //Adornments
          let startAdornment = undefined;
          if (selected && selected.name && showStartAdornment) {
            const badgeStyle = {
              width: '25px',
              height: '25px',
              fontSize: '14px',
              marginRight: '1rem',
              borderRadius: '50%',
              backgroundColor: selected.categoryColor,
              fontWeight: 'bold',
              color: 'white'
            };


            startAdornment = (

              <InputAdornment position="start">
                <Grid item container justify='center' alignItems='center' style={{ ...badgeStyle, alignItems: 'center' }}>
                  {GetCategoryBadge(selected.name)}
                </Grid>
              </InputAdornment>
            );

          }

          let inputColorStyle = params.inputProps ? params.inputProps : {}
          inputColorStyle.style = { color: (selected && selected.categoryColor && showStartAdornment) ? selected.categoryColor : 'black' }

          const newParams = { ...params, ...inputColorStyle }

          //newInputProps
          const newInputProps = {
            ...newParams.InputProps,

            startAdornment: (
              <React.Fragment>
                {
                  startAdornment
                }

                {params.InputProps.startAdornment}
              </React.Fragment>
            ),
            endAdornment: (
              <React.Fragment>
                {
                  (open === true) ?
                    <ExpandLessIcon id={idToSet ? `${idToSet}_close_btn` : 'dropdown_close_btn'} style={{ color: 'black', cursor: 'pointer' }} />
                    :
                    <ExpandMoreIcon id={idToSet ? `${idToSet}_open_btn` : 'dropdown_open_btn'} style={{ color: 'black', cursor: 'pointer' }} />
                }

                {params.InputProps.endAdornment}
              </React.Fragment>
            ),
            classes: { ...stylesObj }
          }


          return (

            <Fragment>
              <TextField
                {...newParams}
                {...input}
                error={error ? error : undefined}
                helperText={helperText ? helperText : undefined}
                //style={{backgroundColor:(open)?'#1f1f1f':'transparent'}}
                onBlur={onBlur}
                autoFocus={autoFocus}
                label={showLabel ? label : undefined}
                InputProps={{ ...newInputProps }}

              />

            </Fragment>
          )
        }
        }
      />
    </Fragment>
  );
};

export const CommunitySelect = ({
  inputStyle = {},
  inputClassName = '',
  input,
  onChangeHandler,
  optionsItemsIconsData,
  selected,
  disabled,
  open,
  anchorEl
}) => {

  const popperWidth = (document.getElementById("communitySelect")) && (document.getElementById("communitySelect").offsetWidth - 15) + 'px';

  return (
    <Fragment>
      <Grid item id='community_communitySelect' container xs={12}>
        <Grid
          className="communitySelectStyles"
          justify='space-between'
          container
          cursor='pointer'
          style={{ backgroundColor: (open === true) ? '#1f1f1f' : 'transparent', padding: '5px', paddingLeft: '10px' }}
        >
          <Grid className="communityNameStyles">{selected.communityName ? selected.communityName : ''}</Grid>
          {
            open === true ?
              <ExpandLessIcon style={{ fontSize: '40px', color: 'white' }} />
              :
              <ExpandMoreIcon style={{ fontSize: '40px' }} color='primary' />
          }
        </Grid>
        <Popper
          open={open}
          className="popperStyles"
          placement='bottom-start'
          anchorEl={anchorEl}
          style={{ width: popperWidth }}
        >
          <Autocomplete
            open
            className="Autocomplete-list"
            id="CommunityCombo"
            disablePortal
            classes={{
              popper: "MuiAutocomplete-popper-community",
              MuiAutocompletepopperDisablePortal: "popperDisablePortal",
              option: "MuiAutocomplete-option-community",
              MuiAutocompletelistbox: "MuiAutocomplete-listbox-community"

            }}
            autoComplete={true}
            options={optionsItemsIconsData}
            value={selected}
            disabled={disabled ? disabled : false}
            getOptionSelected={(option, value) => option === value ? true : false}
            getOptionLabel={option => option.communityName ? option.communityName : ''}
            renderOption={(option) => {

              const idConst = `community_communitySelect_${option.communityId}`;
              return (
                <Grid id={idConst} container className={(option.indexForCombo % 2 === 0) ? "rowContainer" : "rowContainerEven"} >
                  <Grid item container justify='space-between'>
                    <Grid item className="CommunityName">{option.communityName}</Grid>
                    <Grid item className="CommunityCity">
                      {`${(option.communityCity) ? option.communityCity + ', ' : ''} ${(option.communityState) ? option.communityState : ''}`}
                    </Grid>
                  </Grid>
                  <Grid container className="CommunityId">
                    <Grid item >{`ID: ${option.communityId}`}</Grid>
                  </Grid>

                </Grid>
              )
            }}
            clearOnEscape
            onChange={onChangeHandler}
            renderInput={(params) => {

              const startAdornment = (
                <InputAdornment position="start">
                  <Icon style={{ marginRight: '10px' }}>
                    <SearchIcon fontSize='large' />
                  </Icon>
                </InputAdornment>
              );

              return (
                <Grid container className="SearchCommunityGrid" alignItems='center'>
                  <InputBase
                    item
                    ref={params.InputProps.ref}
                    inputProps={params.inputProps}
                    autoFocus
                    placeholder='Search'
                    className="SearchCommunity"
                    startAdornment={startAdornment}
                  />
                </Grid>
              )
            }
            }
          />
        </Popper>

      </Grid>

    </Fragment>
  );
};

export const MealSelect = ({
  label,
  input,
  onChangeHandler,
  optionsItemsIconsData,
  selected,
  disabled,
  idToSet = undefined
}) => {


  return (
    <Fragment>
      <Autocomplete

        style={{ width: '100%', marginLeft: 'auto', marginRight: 'auto', marginTop: 'auto', marginBottom: '0', paddingRight: '15px' }}
        id={idToSet ? idToSet : "combo-box-demo"}
        options={optionsItemsIconsData}
        value={selected}
        disabled={disabled ? disabled : false}
        getOptionSelected={(option, value) => option === value ? true : false}
        getOptionLabel={option => option.mealName ? option.mealName : ''}
        renderOption={option => {
          return (
            <Fragment>
              <p style={{ marginBottom: '0', marginTop: '0', marginLeft: '10px' }}>{option.mealName}</p>
            </Fragment>
          )
        }}
        clearOnEscape
        onChange={onChangeHandler}
        renderInput={(params) => (<Fragment>
          <TextField
            {...params}
            {...input}
          />
        </Fragment>
        )}
      />
    </Fragment>
  );
};

export const ResidentSelect = ({
  label,
  style,
  input,
  onChangeHandler,
  optionsItemsIconsData,
  selected,
  disabled,
  idToSet = undefined,
}) => {

  const filterOptions = createFilterOptions({
    stringify: (option) => 
      `${option.firstName} ${option.lastName} ${option.zoneName}`.toLowerCase()
  });

  return (
    <Fragment>
      <Autocomplete
        id={idToSet ? idToSet : 'combo-box-demo'}
        style={style}
        options={optionsItemsIconsData}
        value={selected}
        disabled={disabled ? disabled : false}
        getOptionSelected={(option, value) => option === value ? true : false}
        getOptionLabel={option => option.firstName ? option.firstName + ' ' + option.lastName : ''}
        renderOption={option => {
          return (
            <Fragment>
              <p style={{ marginBottom: '0', marginTop: '0', marginLeft: '10px' }}>{`${option.firstName} ${option.lastName} - ${option.zoneName}`}</p>
            </Fragment>
          )
        }}
        filterOptions={filterOptions}
        clearOnEscape
        onChange={onChangeHandler}
        renderInput={(params) => (<Fragment>
          <TextField
            {...params}
            label={label}
          />
        </Fragment>
        )}
      />
    </Fragment>
  );
};


export const LegacySimpleSelect = ({
  showStartAdornment = false,
  showLabel = false,
  label,
  input,
  onChangeHandler,
  optionsItemsIconsData,
  selected,
  disabled,
  error = undefined,
  helperText = undefined,
  open,
  onBlur,
  autoFocus,
  stylesObj = undefined,
  idToSet = undefined,
}) => {
  return (
    <Fragment>
      <Autocomplete
        id={idToSet ? idToSet : 'combo-box-demo'}
        open={open}
        freeSolo
        disableClearable
        style={{ width: '100%', marginLeft: 'auto', marginRight: 'auto', marginTop: 'auto', marginBottom: '0', paddingRight: '15px', }}
        options={optionsItemsIconsData}
        value={selected}
        disabled={disabled ? disabled : false}
        classes={{
          option: "LMuiAutocomplete-option-community",
          listbox: "LMuiAutocomplete-listbox"
        }}
        getOptionSelected={(option, value) => option === value ? true : false}
        getOptionLabel={option => option.name ? option.name : ''}
        renderOption={option => {

          let startAdornment = undefined;

          if (option.categoryColor && showStartAdornment) {

            const badgeStyle = {
              width: '25px',
              height: '25px',
              fontSize: '14px',
              marginRight: '1rem',
              borderRadius: '50%',
              backgroundColor: option.categoryColor,
              fontWeight: 'bold',
              color: 'white'
            }

            startAdornment = (
              <Grid item container justify='center' alignItems='center' style={{ ...badgeStyle, alignItems: 'center' }}>
                {GetCategoryBadge(option.name)}
              </Grid>
            )
          }


          return (
            <Fragment>
              <Grid item container className={(!option.indexForCombo) ? "optionRow" : (option.indexForCombo % 2 === 0) ? "optionRow" : "optionRowEven"}>
                <Grid item>{startAdornment}</Grid>
                <Grid item style={{ color: (option.categoryColor && showStartAdornment) ? option.categoryColor : '#707070' }}>{option.name}</Grid>
              </Grid>
            </Fragment>
          )
        }}
        clearOnEscape
        onChange={onChangeHandler}
        renderInput={(params) => {

          //Adornments
          let startAdornment = undefined;
          if (selected && selected.name && showStartAdornment) {
            const badgeStyle = {
              width: '25px',
              height: '25px',
              fontSize: '14px',
              marginRight: '1rem',
              borderRadius: '50%',
              backgroundColor: selected.categoryColor,
              fontWeight: 'bold',
              color: 'white'
            };


            startAdornment = (

              <InputAdornment position="start">
                <Grid item container justify='center' alignItems='center' style={{ ...badgeStyle, alignItems: 'center' }}>
                  {GetCategoryBadge(selected.name)}
                </Grid>
              </InputAdornment>
            );

          }

          let inputColorStyle = params.inputProps ? params.inputProps : {}
          inputColorStyle.style = { color: (selected && selected.categoryColor && showStartAdornment) ? selected.categoryColor : 'white' }

          const newParams = { ...params, ...inputColorStyle }

          //newInputProps
          const newInputProps = {
            ...newParams.InputProps,

            startAdornment: (
              <React.Fragment>
                {
                  startAdornment
                }

                {params.InputProps.startAdornment}
              </React.Fragment>
            ),
            endAdornment: (
              <React.Fragment>
                {
                  (open === true) ?
                    <ExpandLessIcon id={idToSet ? `${idToSet}_close_btn` : 'dropdown_close_btn'} style={{ color: 'black', cursor: 'pointer' }} />
                    :
                    <ExpandMoreIcon id={idToSet ? `${idToSet}_open_btn` : 'dropdown_open_btn'} style={{ color: 'black', cursor: 'pointer' }} />
                }

                {params.InputProps.endAdornment}
              </React.Fragment>
            ),
            classes: { ...stylesObj }
          }


          return (

            <Fragment>
              <TextField
                {...newParams}
                {...input}
                error={error ? error : undefined}
                helperText={helperText ? helperText : undefined}
                //style={{backgroundColor:(open)?'#1f1f1f':'transparent'}}
                onBlur={onBlur}
                autoFocus={autoFocus}
                label={showLabel ? label : undefined}
                InputProps={{ ...newInputProps }}

              />

            </Fragment>
          )
        }
        }
      />
    </Fragment>
  );
};

//#endregion
export const renderFixedSelect = ({
  label,
  input,
  onChangeHandler,
  optionsList,
  selected,
  name,
  meta: { touched, invalid, error },
  ...custom
}) => {

  return (
    <Fragment>
      <Select
        style={{ width: '100%', marginLeft: 'auto', marginRight: 'auto', marginTop: 'auto', marginBottom: '0', paddingRight: '15px' }}
        id={name}
        options={optionsList}
        value={selected}
        getOptionSelected={(option, value) => option === value ? true : false}
        getOptionLabel={option => option.name ? option.name : ''}
        clearOnEscape
        onChange={onChangeHandler}
      />
    </Fragment>
  );
};



//#region switchtwoOptions
export const SwitchTwoOptions = ({
  leftOptionLabel,
  rightOptionLabel,
  selectedOption,
  onOptionChange,
  idToSet = undefined
}) => {

  if (!leftOptionLabel) {
    leftOptionLabel = 'option'
  }

  if (!rightOptionLabel) {
    rightOptionLabel = 'option'
  }

  if (selectedOption !== 0 && selectedOption !== 1) {
    selectedOption = 0;
  }

  const idComponent = idToSet ? idToSet : 'switchTwoOptions';

  return (
    <Grid container justify='space-between' alignItems='center' id={idComponent}>
      <Grid item container xs={12} className="twoOptionsConteiner">
        <Button variant="contained" id={`${idComponent}_LeftOption`} className={(selectedOption === 0) ? "selectedOption" : "noSelectedOption"} onClick={() => onOptionChange(0)}
          disableElevation disableRipple={true} disableFocusRipple={true}>
          {leftOptionLabel}
        </Button>
        <Button variant="contained" id={`${idComponent}_RightOption`} className={(selectedOption === 1) ? "selectedOption" : "noSelectedOption"} onClick={() => onOptionChange(1)}
          disableElevation disableRipple={true} disableFocusRipple={true}>
          {rightOptionLabel}
        </Button>
      </Grid>
    </Grid>
  );
}
//#endregion

//#region ChecronList

export const ChevronList = ({
  onArrowClick,
  optionSelected,
  onChangeHandler,
  placeHolder = '',
  idToSet = undefined,
  textClass = 'chevronListText',
  buttonClass = 'chevronListButton'
}) => {

  const stylesArrows = {
    color: (textClass && textClass === 'LChevronListText') ? '#707070' : 'white'
  };
  return (
    <Grid item container xs={12} alignItems='flex-end' justify='center'>
      <Grid item xs={6}>
        <TextField id={idToSet ? idToSet : 'chevronlistcomponent'} placeholder={placeHolder} onChange={(e) => onChangeHandler(e, placeHolder)} value={optionSelected ? optionSelected.text : undefined} inputProps={{ className: textClass }}></TextField>
      </Grid>

      <Grid item container xs={3} direction='column' style={{ textAlign: 'center', }}  >
        <Grid item>
          <Grid id={idToSet ? idToSet + '_up_arrow' : 'chevronlistcomponent_uparrow'} className={buttonClass} onClick={() => onArrowClick('Up', placeHolder)}>
            <ArrowDropUpIcon style={stylesArrows} fontSize='large' />
          </Grid>
        </Grid>

        <Grid item>
          <Grid id={idToSet ? idToSet + '_down_arrow' : 'chevronlistcomponent_downarrow'} className={buttonClass} onClick={() => onArrowClick('Down', placeHolder)}>
            <ArrowDropDownIcon style={stylesArrows} fontSize='large' />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export const Chevronlistv2 = ({
  onArrowClick,
  optionSelected,
  onChangeHandler,
  placeHolder = '',
  idToSet = undefined,
  textClass = 'chevronListText',
  buttonClass = 'chevronListButton'
}) => {

  return (
    <Grid item container xs={12} alignItems='baseline' justifyContent='center'>
      <Grid item xs={10}>
        <TextField id={idToSet ? idToSet : 'chevronlistcomponent'} placeholder={placeHolder} onChange={(e) => onChangeHandler(e, placeHolder)} value={optionSelected ? optionSelected.text : undefined} inputProps={{ className: textClass }}></TextField>
      </Grid>
    </Grid>
  );
};

export const ActivityChevronList = ({
  onArrowClick,
  optionSelected,
  onChangeHandler,
  onKeyDown,
  startend = '',
  placeHolder = '',
  idToSet = undefined
}) => {

  return (
    <Grid item container xs={12} alignItems='flex-end' justify='center'>
      <Grid item xs={6}>
        <TextField
          onKeyDown={onKeyDown}
          id={idToSet ? idToSet : 'chevronlistcomponent'}
          placeholder={placeHolder}
          onChange={(e) => onChangeHandler(e, startend)}
          value={optionSelected ? optionSelected.text : undefined}
          inputProps={{ className: "chevronListText" }}
        ></TextField>
      </Grid>

      <Grid item container xs={3} direction='column' style={{ textAlign: 'center', }}  >
        <Grid item>
          <Grid id={idToSet ? idToSet + '_up_arrow' : 'chevronlistcomponent_uparrow'} className="chevronListButton" onClick={() => onArrowClick('Up', startend)}>
            <ArrowDropUpIcon style={{ color: 'white' }} fontSize='large' />
          </Grid>
        </Grid>

        <Grid item>
          <Grid id={idToSet ? idToSet + '_down_arrow' : 'chevronlistcomponent_downarrow'} className="chevronListButton" onClick={() => onArrowClick('Down', startend)}>
            <ArrowDropDownIcon style={{ color: 'white' }} fontSize='large' />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

//#endregion

//#region RenderSearchComponent
export const RenderSearchComponent = ({
  isOpen = false,
  closeStyles = {},
  searchInput = undefined,
  onChangeHandler = undefined,
  onClickHandler = undefined,
  idToSet = undefined
}) => {
  let innerSearchInput = searchInput ? searchInput : '';

  //#region  inner search handlers
  const innerChangeSearchInput = (e) => {
    if (e && e.target && e.target.value) {

      innerSearchInput = e.target.value;
    } else {
      innerSearchInput = '';
    }
  }
  //#endregion

  const startAdornment =
    (

      <InputAdornment position='start'>
        <IconButton aria-label="SearchIcon" style={{ padding: '0' }} onClick={() => onChangeHandler(innerSearchInput)}>
          <SearchIcon color='secondary' style={{ ...closeStyles, padding: '0' }} />
        </IconButton>
      </InputAdornment>
    )

  const endAdornment =
    (
      <InputAdornment position='end' >
        <IconButton
          id={idToSet ? `${idToSet}_close_btn` : 'searchComponentCloseBtn'}
          aria-label="SearchIcon"
          onClick={() => onClickHandler(false)}
          style={{ ...closeStyles, cursor: 'pointer', padding: '0' }}
        >
          <HighlightOffIcon
            style={{ ...closeStyles, cursor: 'pointer', padding: '0' }}
          />
        </IconButton>
      </InputAdornment>
    )

  const openComponent =
    (

      <TextField
        id={idToSet ? idToSet : 'searchComponent'}
        autoFocus={true}
        onChange={innerChangeSearchInput}
        defaultValue={innerSearchInput}
        style={{ background: '#454446', width: '250px', height: '45px', borderRadius: '22px' }}
        InputProps=
        {{
          className: 'textField',
          disableUnderline: true,
          startAdornment: startAdornment,
          endAdornment: endAdornment,
        }}
      />
    )

  const closeComponnet =
    (
      <IconButton aria-label="SearchIcon" onClick={() => onClickHandler(true)}>
        <SearchIcon color='secondary' style={closeStyles} />
      </IconButton>
    )

  return (
    <Grid item container justify='flex-end' alignItems='center' style={{ height: '100%' }}>
      <Grid item>
        {
          isOpen ?
            openComponent
            :
            closeComponnet
        }
      </Grid>
    </Grid>
  );

};

//#endregion



//#region  MULTIPLE DATES PICKER
export const MultipleDatesPicker = ({
  itemsSelected = undefined,
  open = false,
  onChangeHandler = undefined,
  paperIncomingStyles = {},
  anchorEl = undefined,
  idToSet = undefined
}) => {

  //#region Methods
  const checkIfNumberIsSelected = (number) => {
    let isSelected = false;

    if (itemsSelected && itemsSelected.find((item) => item.number === number)) {
      isSelected = true;
    } else {
      isSelected = false;
    }

    return isSelected;
  };

  const GetNumberObject = (number) => {
    const lastDigit = number ? (number % 10) : 1;

    let ordinal = '';

    if (number >= 11 && number <= 13) {
      ordinal = number + 'th'
    } else {
      switch (lastDigit) {
        case 1:
          ordinal = number + 'st';
          break;
        case 2:
          ordinal = number + 'nd';
          break;
        case 3:
          ordinal = number + 'rd';
          break;
        default:
          ordinal = number + 'th';
          break;
      }
    }

    return {
      number: number,
      ordinal: ordinal,
    }
  }
  //#endregion

  //#region INNER COMPONENTS
  const GetDayNumberComponent = (item, isSelected) => {

    const classes = isSelected ? 'MultiPickerCellStyles MultiPickerSelectedCellStyles' : 'MultiPickerCellStyles';

    return (
      <Grid item
        id={`idDay_${item.number}`}
        className={classes}
        key={'multuipickerChild' + item.number}
        onClick={() => onChangeHandler(item)}
      >
        {item.number}
      </Grid>
    );
  }
  //#endregion

  return (
    <Popper className='MultiPickerPopOver' open={open} anchorEl={anchorEl}>
      <Grid container id={idToSet ? idToSet : 'Monthly_picker'}>
        <Grid item xs={12} style={{ padding: '5px 0px' }}>
          Select One or More Days to Repeat
        </Grid>
        <Grid item container justify='center' xs={12}>
          <Grid item container xs={11} justify='flex-start'>
            {
              [...Array.from({ length: 31 }, (_, i) => i + 1)].map(
                (item) => GetDayNumberComponent(

                  GetNumberObject(item),
                  checkIfNumberIsSelected(item)
                )
              )
            }
          </Grid>

        </Grid>
      </Grid>
    </Popper>

  )
}
//#endregion


//#region  CUSTOM DATES PICKER
export const CustomDatesPicker = ({
  repeatOptions = undefined,
  repeatValue = undefined,
  onRepeatValueChangeHandler = undefined,

  repeatInterval = '',
  onChangeRepeatIntervalHandler = undefined,

  customPickerSelectedDays = undefined,
  onCustomPickerWeeklySelectionChangeChandler = undefined,

  monthlyOptionSelected = undefined,
  onCustomMonthlyRepeatChangeHandler = undefined,

  onActionSelected = undefined,

  mealStartDate = undefined,

  repeatIntervalTouched = undefined,
  repeatValueTouched = undefined,
  repeatCustomMonthlySelectionTouched = undefined,
  repeatIntervalError = undefined,
  repeatValueError = undefined,
  repeatCustomMonthlySelectionError = undefined

}) => {

  const date = (mealStartDate) ? new Date(mealStartDate) : new Date();
  const now = (mealStartDate) ? new moment(mealStartDate) : new moment();

  const thisMonth = now.clone();

  const startOfMonth = thisMonth.clone().startOf('month');
  const endOfMonth = thisMonth.clone().endOf('month');

  let startOfWeek = startOfMonth.clone().startOf('week');
  let endOfWeek = startOfMonth.clone().endOf('week');

  let weekNumber = 1;

  const ordinals = [
    'fisrt',
    'second',
    'third',
    'fourth',
    'fifth',
    'sixth',
  ]

  const arrayWeeks = [];

  while (startOfWeek < endOfMonth) {
    arrayWeeks.push(
      {
        number: weekNumber,
        min: startOfWeek.clone(),
        max: endOfWeek.clone(),
        ordinal: (ordinals && ordinals[weekNumber - 1]) ? ordinals[weekNumber - 1] : 'last'
      }
    )

    startOfWeek = startOfWeek.add(1, 'week');
    endOfWeek = endOfWeek.add(1, 'week');
    weekNumber = weekNumber + 1;
  }

  const thisWeekOption = arrayWeeks.find((item) => item.min <= now && now <= item.max);

  const monthlyOptions = [
    {
      label: `the ${(now) ? now.format('Do') : '1st'} day`,
      day: now.format('DD'),
      value: '0',
      dateNumber: date.getDate(),
      weekNumber: thisWeekOption.number,
      dayNumber: date.getDay(),
    },
    {
      label: `the ${(thisWeekOption && thisWeekOption.ordinal) ? thisWeekOption.ordinal : 'first'} ${now.format('dddd')}`,
      day: now.format('DD'),
      value: '1',
      dateNumber: new Date().getDate(),
      weekNumber: thisWeekOption.number,
      dayNumber: date.getDay(),
    },
  ]

  return (
    <Grid item container style={{ color: 'white', height: '100%', fontSize: '20px' }}>
      {/* Row */}
      <Grid item container justify='flex-start' alignContent='flex-end' style={{ padding: '15px', height: '33%' }} >
        <Grid item container xs={12} md={4} style={{ paddingLeft: '10px', paddingRight: '10px' }}>
          Repeat every:
        </Grid>
        <Grid item container xs={4} md={2} style={{ paddingLeft: '10px', paddingRight: '10px' }}>
          <TextField
            id={`repeatEvery_Interval`}
            value={repeatInterval ? repeatInterval : ''}
            onChange={onChangeRepeatIntervalHandler}
            helperText={repeatIntervalTouched && repeatIntervalError}
          />
        </Grid>
        <Grid item container xs={4} md={4} style={{ paddingLeft: '10px', paddingRight: '10px' }}>
          <Select
            id={`repeatValue_RepeatSelect`}
            value={repeatValue}
            style={{ width: '100%' }}
            onChange={onRepeatValueChangeHandler}
            helperText={repeatValueTouched && repeatValueError}
          >
            {
              (repeatOptions && repeatOptions.length > 0) ?
                repeatOptions.map((item, index) => (
                  <MenuItem id={`repeatEvery_repeatOption_${index}`} value={item.value} classes={{ root: `${(index % 2 === 0) ? 'SelectBackground' : 'SelectBackground oddRowSelect'}` }} >{item.label}</MenuItem>
                ))
                :
                undefined
            }
          </Select>
        </Grid>
      </Grid>

      {/* Row */}
      <Grid item container justify='flex-start' style={{ padding: '15px', height: '33%' }}>
        {
          (repeatValue && repeatValue.length && repeatValue.toLowerCase() === 'weekly') ?

            <WeekDayPicker
              selectedDays={customPickerSelectedDays ? customPickerSelectedDays : []}
              onChangeHandler={(itemSelected) => onCustomPickerWeeklySelectionChangeChandler(itemSelected)}
            />
            :
            undefined
        }
        {
          (repeatValue && repeatValue.length && repeatValue.toLowerCase() === 'monthly') ?
            <Grid item container justify='flex-start' alignContent='flex-end'>
              <Grid item container xs={12} md={4} style={{ paddingLeft: '10px', paddingRight: '10px' }}>
                Repeat on:
              </Grid>
              <Grid item conteiner xs={12} md={7} style={{ paddingLeft: '10px', paddingRight: '10px' }}>
                <Select
                  id={`RepeatOn_Select`}
                  value={monthlyOptionSelected}
                  style={{ width: '100%' }}
                  onChange={(event) => {

                    const value = (event && event.target && event.target.value) ? event.target.value : undefined;

                    if (value) {

                      const optionSelected = (monthlyOptions && monthlyOptions[value]);
                      if (optionSelected) {

                        onCustomMonthlyRepeatChangeHandler(optionSelected)
                      }
                    }
                  }}
                  helperText={repeatCustomMonthlySelectionTouched && repeatCustomMonthlySelectionError}
                >
                  {
                    (monthlyOptions && monthlyOptions.length > 0) ?
                      monthlyOptions.map((item, index) => (
                        <MenuItem id={`RepeatOn_Option_${index}`} value={item.value} classes={{ root: `${(index % 2 === 0) ? 'SelectBackground' : 'SelectBackground oddRowSelect'}` }} >{item.label} </MenuItem>
                      ))
                      :
                      undefined
                  }
                </Select>
              </Grid>
            </Grid>
            :
            undefined
        }
      </Grid>

      {/* Row */}
      <Grid item container xs={12} justify='flex-end' alignContent='center' style={{ padding: '15px', height: '33%' }}>
        <Grid
          id='customDates_cancelBtn'
          item
          container
          xs={3}
          className={"blueBottomButon appbtnBarButton"}
          style={{ width: '154px', backgroundColor: '#959494', }}
          onClick={() => onActionSelected(0)}
          alignContent='center'
          justify='center'
        >
          <Grid item>
            Cancel
          </Grid>
        </Grid>

        <Grid
          id='customDates_saveBtn'
          item xs={3}
          className={"blueBottomButon appbtnBarButton"}
          style={{ width: '154px', marginLeft: '10px' }}
          onClick={() => onActionSelected(1)}
          alignContent='center'
          justify='center'
        >
          <Grid item>
            Save
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}
//#endregion

//#region WEEKDAY PICKER
export const WeekDayPicker = ({
  selectedDays = undefined,
  onChangeHandler = undefined,
  idToSet = undefined,
  meta,
  ...custom
}) => {


  const touched = (meta && meta.touched) ? meta.touched : undefined;
  const invalid = (meta && meta.invalid) ? meta.invalid : undefined;
  const error = (meta && meta.error) ? meta.error : undefined;

  const days = [
    {
      number: 0,
      name: 'Sunday',
      text: 'Sun'
    },
    {
      number: 1,
      name: 'Monday',
      text: 'Mon'
    },
    {
      number: 2,
      name: 'Tuesday',
      text: 'Tue'
    },
    {
      number: 3,
      name: 'Wednesday',
      text: 'Wed'
    },
    {
      number: 4,
      name: 'Thursday',
      text: 'Thu'
    }
    , {
      number: 5,
      name: 'Friday',
      text: 'Fri'
    },
    {
      number: 6,
      name: 'Saturday',
      text: 'Sat'
    }
  ];



  //#region Inner Componnets
  const DayComponent = (dayObject) => {
    return (
      <Grid item container className='weeDayStyles' justify='center' alignItems='center' key={'dayComponnet_' + dayObject.number} error={true} >
        <Grid item xs={12} className='CheckboxBlue' style={{ textAlign: 'center' }} >
          <Checkbox
            id={idToSet ? idToSet + '_' + dayObject.number : 'weekPicker_' + dayObject.number}
            checked={(selectedDays && selectedDays.find((item) => item.number === dayObject.number))}
            onChange={() => onChangeHandler(dayObject)}
            icon={<CheckBoxOutlineBlankIcon fontSize="large" />}
            checkedIcon={<CheckBoxIcon fontSize="large" />}
          />
        </Grid>
        <Grid item xs={12} style={{ textAlign: 'center' }}>{dayObject.text}</Grid>
      </Grid>
    );
  }
  //#endregion

  return (
    <Grid
      item
      container
      id={idToSet ? idToSet : 'weekPicker'}
    >
      {
        days.map((dayObject) => DayComponent(dayObject))
      }
      {
        ((touched && invalid) && (touched && error)) ?
          <div style={{ color: '#d93e33', fontSize: '12px' }}>{error}</div>
          :
          undefined

      }
    </Grid>
  );
}
//#endregion

//#region  Render Selcet Custom
export const RenderSelectCustom = ({
  idToSet = undefined,
  open,
  optionSelected,
  options,
  startAdornment = undefined,
  endAdornment = undefined,
  label,
  diableClear = false,
  onBlur = undefined,
  onChangeHandler = undefined,
  optionClass = undefined,
  input,
  disabled,
  inputLabelClass = undefined,
  inputClass = undefined,
  autoCompleteStyles = {},
  meta: { touched, invalid, error },
  ...custom
}) => {

  const RenderSingleOption = (option) => {
    try {

      return (
        <Grid item container >
          <Grid item className={optionClass ? optionClass : undefined}>{option.name}</Grid>
        </Grid>
      )
    } catch (err) {
      return (
        <Grid item container></Grid>
      )
    }
  }

  const RenderInput = (params) => {
    try {

      let newInputProps = params.InputProps ? params.InputProps : {}
      if (startAdornment) {
        newInputProps.startAdornment = startAdornment;
      }
      const localEndAdornment = (
        <InputAdornment position="start">
          {
            (endAdornment) ?
              endAdornment
              :
              undefined
          }
          {
            (!diableClear && optionSelected != null && optionSelected?.name !== '' && optionSelected.name?.length > 0) ?
              <IconButton onClick={() => { onChangeHandler(null, { name: '' }) }}>
                <ClearIcon style={{ color: 'white' }} fontSize="small" />
              </IconButton> : ""
          }
          {
            (open === true) ?
              <ExpandLessIcon style={{ color: 'white', cursor: 'pointer' }} />
              :
              <ExpandMoreIcon style={{ color: 'white', cursor: 'pointer' }} />
          }
        </InputAdornment>
      );

      newInputProps.endAdornment = localEndAdornment;
      newInputProps.className = " categoryDropDown";

      let inputColorStyle = params.inputProps ? params.inputProps : {}

      if (optionSelected != null) {
        inputColorStyle.value = inputColorStyle.value !== "" ? inputColorStyle.value : optionSelected !== undefined ? optionSelected.name : "";
        inputColorStyle.style = { color: 'white' }
      }
      const newParams = { ...params, newInputProps, ...inputColorStyle };

      return (
        <Fragment>
          <TextField
            {...newParams}
            label={label}
            error={touched && invalid}
            helperText={touched && error}
            {...input}
            {...custom}
            InputLabelProps={{ className: inputLabelClass }}
            value={optionSelected}

          />
        </Fragment>
      )

    } catch (err) {
      return (
        <Grid item container></Grid>
      )
    }
  }

  return (
    <Fragment>
      <Autocomplete
        id={idToSet ? idToSet : 'combo-box-demo'}
        open={open}
        options={options}
        defaultValue={optionSelected}
        error={touched && invalid}
        helperText={touched && error}
        onBlur={onBlur ? onBlur : undefined}
        disabled={disabled ? disabled : false}
        getOptionSelected={(option, value) => option === value ? true : false}
        getOptionLabel={option => option.name ? option.name : ''}
        renderOption={option => RenderSingleOption(option)}
        clearOnEscape
        onChange={onChangeHandler}
        value={optionSelected}
        renderInput={(params) => RenderInput(params)}
        style={{ width: '100%' }}
      />
    </Fragment>
  );
};
//#endregion